/*
js file for hindi recommedations page 
*/
document.addEventListener('DOMContentLoaded', function () {
     (function() {
    var currentUrl = window.location.href.toLowerCase();
    var logoLink = document.querySelector('.recommendation-header-left');

    if (logoLink) {
      if (currentUrl.includes('marathi')) {
        logoLink.setAttribute('href', 'https://www.theclinderma.com/pages/marathi-home-page');
      } 
      else if (currentUrl.includes('hindi')) {
        logoLink.setAttribute('href', 'https://www.theclinderma.com/pages/hindi-home-page');
      }
    }
  })();
         const copyBtns = document.querySelectorAll(".coupon-btn");
  
  // 2. Loop through the list to handle each button individually
  copyBtns.forEach(function(btn) {
    
    // 3. Attach the event listener to the individual button ('btn')
    btn.addEventListener("click", function() {
      
      // 4. Dynamically find the text span inside the strictly clicked button
      const textSpan = this.querySelector('.coupon-btn-text');
      if (!textSpan) return; // Safety check

      // Dynamically read the actual text string (e.g., "Clinderma200") 
      // instead of hardcoding one value for all buttons
      const codeToCopy = textSpan.innerText.trim();
      const originalText = textSpan.innerText;
      
      navigator.clipboard.writeText(codeToCopy)
        .then(() => {
          // Visual feedback changes
          textSpan.innerText = "Code Copied!";
          this.style.background = "rgba(238, 242, 244, 0.2)"; 
          this.style.borderColor = "#678EBC"; 
          
          // Reset back to original state after 2 seconds
          setTimeout(() => {
            textSpan.innerText = originalText;
            this.style.background = "transparent"; 
            this.style.borderColor = "#EEF2F4";    
          }, 2000);
        })
        .catch(err => {
          console.error("Failed to copy text: ", err);
        });
    });
    
  });
     // =========================================================
   const diagnosisEl = document.getElementById('skin-diagnosis');
    const thumbEl = document.getElementById('acne-thumb');
    const storedAcneTypes = JSON.parse(localStorage.getItem('userAcneSelections') || '[]');

    let diagnosisText = 'मुंहासे';
    let thumbValue = '0%'; 

    // Priority Logic: Check for the most severe conditions first
    if (storedAcneTypes.includes('Large painful bumps') || storedAcneTypes.includes('Pus filled pimples')) {
        diagnosisText = 'गंभीर मुंहासे';
        thumbValue = '95%'; 
    } 
    else if (storedAcneTypes.includes('Small red bumps')) {
        diagnosisText = 'मध्यम मुंहासे';
        thumbValue = '50%';
    } 
    else if (storedAcneTypes.includes('Whiteheads or blackheads')) {
        diagnosisText = ' सौम्य मुरुम';
        thumbValue = '25%';
    } 
    else if (storedAcneTypes.includes('Occasional breakouts')) {
        diagnosisText = 'कभी-कभी होने वाले मुंहासे';
        thumbValue = '10%';
    }

    // Update UI
    if (diagnosisEl) {
        diagnosisEl.textContent = diagnosisText;
    }
    if (thumbEl) {
        // Delay slightly to allow the meter to animate smoothly
        setTimeout(() => {
            thumbEl.style.left = thumbValue;
        }, 300);
    }
// }
 const videoCards = document.querySelectorAll('.item-video-card,.medical-expert-item-video-card');

  videoCards.forEach(card => {
    const video = card.querySelector('video');
    const overlay = card.querySelector('.video-overlay');
    const playBtn = card.querySelector('.play-button-wrapper');

    if (!video || !overlay) return; // Safety check

    function togglePlay() {
      if (video.paused) {
        // 1. Play the video
        video.play();
        // 2. Hide the play button
        if (playBtn) playBtn.style.opacity = '0';
      } else {
        // 1. Pause the video
        video.pause();
        // 2. Show the play button again
        if (playBtn) playBtn.style.opacity = '1';
      }
    }

    // Add click event to the overlay (which covers the video)
    overlay.addEventListener('click', togglePlay);
  });
    });
    console.log("Script Loaded: Dual Image Logic + Popup Fixes Applied");
const faqPlusIcon = `<svg class="icon-plus" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="transparent"><path d="M9.92454 19.5428V10.839H0.457245C0.204758 10.839 6.92713e-05 10.6343 0 10.3818C2.21915e-08 10.1293 0.204716 9.92454 0.457245 9.92454H9.92454V0.457245C9.92454 0.204716 10.1293 0 10.3818 0C10.6343 6.88006e-05 10.839 0.204758 10.839 0.457245V9.92454H19.5428C19.7952 9.92459 20 10.1293 20 10.3818C19.9999 10.6342 19.7952 10.839 19.5428 10.839H10.839V19.5428C10.839 19.7952 10.6342 19.9999 10.3818 20C10.1293 20 9.92459 19.7952 9.92454 19.5428Z" fill="#2F444E"/></svg>`;
    const faqMinusIcon = `<svg class="icon-minus" xmlns="http://www.w3.org/2000/svg" width="19" height="1" viewBox="0 0 19 1" fill="transparent"><path d="M0.5 0.5H18.5" stroke="#2F444E" stroke-linecap="round"/></svg>`;
    // =========================================================
    // 0. MARQUEE & HIGHLIGHT LOGIC
    // =========================================================
    const trustWrapper = document.querySelector('.marquee-wrapper');
    const marqueeContent = document.querySelector('.marquee-content');

    if (marqueeContent) {
        const originalHtml = marqueeContent.innerHTML;
        marqueeContent.innerHTML = '';
        for (let i = 0; i < 10; i++) {
            marqueeContent.innerHTML += originalHtml;
        }
    }

    const trustItems = document.querySelectorAll('.trust-item');
    function highlightCenterItem() {
        if (!trustWrapper || trustItems.length === 0) return;
        const wrapperRect = trustWrapper.getBoundingClientRect();
        const wrapperCenter = wrapperRect.left + (wrapperRect.width / 2);

        trustItems.forEach(item => {
            const itemRect = item.getBoundingClientRect();
            const itemCenter = itemRect.left + (itemRect.width / 2);
            const distance = Math.abs(wrapperCenter - itemCenter);
            if (distance < 80) item.classList.add('active');
            else item.classList.remove('active');
        });
        requestAnimationFrame(highlightCenterItem);
    }
    highlightCenterItem();


    // =========================================================
    // 1. DATA: ALL PRODUCT INFO
    // =========================================================
    const allProductInfo = {
         "52624025157944":
        {
image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/dermatology_tag_acnetrol_moisturiser.png?v=1783579714",
            
            // 2. SUPPORTIVE SECTION IMAGE (PASTE YOUR NEW LINK HERE)
             images: ["https://cdn.shopify.com/s/files/1/0916/8178/4120/files/acnetrol-moisturiser_1.png?v=1783579714"],
  title: "Acnetrol Moisturiser",
            description: "SPF वाला Acnetrol मॉइस्चराइज़र त्वचा को दिनभर हाइड्रेटेड, सुरक्षित और आरामदायक रखता है।",
            quantityLabel: "75g",
            price: 589,
              benefits: ["त्वचा की बैरियर रिपेयर करे", "पोर्स कम करे"],
            composition:'Aqua, Ethylhexyl Methoxycinnamate, Sodium Polyacrylate, Dimethicone, Cyclopentasiloxane, Trideceth-6, PEG/PPG-18/18 Dimethicone, Glycerin, Methylene Bis-Benzotriazolyl Tetramethylbutylphenol, Decyl Glucoside, Propylene Glycol, Xanthan Gum, C13-15 Alkane, Xylitylglucoside, Anhydroxylitol, Xylitol, Laminaria Digitata Extract, Cetyl-PG Hydroxyethyl Palmitamide, Ceramide 1, Ceramide 2, Ceramide 3, Ceramide 4, Ceramide 6ii, Squalane (Olive), Cetearyl Olivate, Sorbitan Olivate, Zanthoxylum Alatum Fruit Extract, Pentylene Glycol, Phyllanthus Emblica Fruit Extract, Glycyrrhiza Glabra Root Extract, Ocimum Sanctum Leaf Extract, Nigella Sativa Seed Extract, Azadirchta Indica Leaf Extract, Phytic Acid, 1,2-Hexanediol, Sodium Hyaluronate, Potassium Hyaluronate, Sodium Hyaluronate Crosspolymer, Sodium Acetylated Hyaluronate, Hydroxypropyltrimonium Hyaluronate, Hydrolyzed Hyaluronic Acid, Hyaluronic Acid, Hydrolyzed Sodium Hyaluronate, Sodium Polyglutamate Crosspolymer, Phenoxyethanol, Ethylhexylglycerin, Tocotrienols, Fragrance, Sodium Gluconate.',
         bestSuitedFor: "सभी प्रकार की त्वचा",
            productForm: "क्रीम",
            areaOfApplication: "चेहरा",
             activeIngredients: [{
                name: "Ceramide:",
                desc: "त्वचा की बैरियर को मज़बूत करता है और नमी को बाहर जाने से रोकता है।",
                tags: ["बैरियर रिपेयर", " डीप हाइड्रेशन"],
                bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/ceramide.png?v=1783579719"
            },
           {
                name: "Hyaluronic Acid:",
                desc: " नमी को खींचकर त्वचा को हाइड्रेटेड और मुलायम रखता है। ",
                tags: ["इंटेंस हाइड्रेशन", "प्लंपिंग"],
                bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Hyaluronic_Acid_2.png?v=1783579717"
            },
            {
                name: "Squalane (Olive-derived)",
                desc: "(ऑलिव से प्राप्त): हल्का मॉइस्चराइज़र जो चिपचिपाहट के बिना त्वचा को पोषण देता है।",
                tags: ["पोषण", "बैरियर सपोर्ट"],
                bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Squalane.png?v=1783579815"
            }],
             faqs: [{ question: "सनस्क्रीन वाला मॉइस्चराइज़र क्या है? ", answer: "सनस्क्रीन वाला मॉइस्चराइज़र एक 2-in-1 स्किनकेयर प्रोडक्ट है जो त्वचा को हाइड्रेट करने के साथ-साथ SPF सुरक्षा भी देता है। यह त्वचा की नमी बनाए रखता है और UVA/UVB किरणों से बचाता है, जो टैनिंग, पिगमेंटेशन और समय से पहले त्वचा की उम्र बढ़ने का कारण बन सकती हैं। " },
                { question: "क्या यह मुंहासे वाली त्वचा के लिए सही है?", answer: "हाँ, इसे मुंहासे वाली त्वचा के लिए तैयार किया गया है। Ceramides, Hyaluronic Acid और Squalane जैसे तत्व त्वचा को भारी महसूस कराए बिना उसे हाइड्रेट करते हैं और बैरियर को मज़बूत बनाते हैं।" },
               
                { question: "क्या यह ऑयली या कॉम्बिनेशन त्वचा के लिए सही है?", answer: "हाँ, इसमें Squalane और Hyaluronic Acid जैसे हल्के मॉइस्चराइज़िंग तत्व हैं जो त्वचा को भारी या चिपचिपा बनाए बिना हाइड्रेट करते हैं।" }]
        },
         "52453188796728":
        {
image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/dermat_badge_facewash.png?v=1780407884s",
            
            // 2. SUPPORTIVE SECTION IMAGE (PASTE YOUR NEW LINK HERE)
            supportiveImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/alite-facewash.png?v=1780406753",
  title: "Alite Anti-Acne Face Wash",
            description: "Alite Anti-Acne Face Wash एक नॉन-कॉमेडोजेनिक फेस वॉश है, जो Encapsulated Activated Charcoal, Sebum Control Enzyme™ और Ceraskin P की मदद से मुंहासों को नियंत्रित करने में सहायता करता है। यह त्वचा के रोमछिद्रों (पोर्स) को गहराई से साफ करता है, अतिरिक्त तेल को नियंत्रित करता है, मुंहासों को कम करने में मदद करता है, त्वचा की जलन को शांत करता है और त्वचा की नमी बनाए रखने में सहायक है। ",
            quantityLabel: "70 ग्रॅम",
            price: 250,
           benefits: ["Acne Control", "Oil Balance"],
            composition:'Encapsulated Activated Charcoal (deep-pore detoxification, 3x targeted delivery), Sebum Control Enzyme™ (sebaceous gland regulation, long-term oil control), Ceramide (barrier replenishment and protection), Spiraea Ulmaria Flower Extract / Meadowsweet (natural salicylates, antibacterial, gentle exfoliation), Aloe Vera Leaf Juice (soothing, hydrating, anti-inflammatory), Glycerin (humectant, moisture retention).',
         bestSuitedFor: "सभी प्रकार की त्वचा",
            productForm: "क्लींजिंग जेल",
            areaOfApplication: "चेहरा",
             faqs: [{ question: "एंटी-एक्ने फेस वॉश क्या है?", answer: "एंटी-एक्ने फेस वॉश मुंहासों को कम करने में मदद करता है। यह चेहरे से अतिरिक्त तेल हटाता है, रोमछिद्रों (पोर्स) को साफ करता है और नए मुंहासों को बनने से रोकता है। Alite Anti-Acne Face Wash मुंहासे वाली त्वचा को साफ और ताज़ा बनाता है, त्वचा की चमक बढ़ाता है और उसे स्वस्थ दिखने में मदद करता है।" },
                { question: "क्या यह फेस वॉश रोज़ इस्तेमाल किया जा सकता है?", answer: "हाँ। यह तैलीय (ऑयली) और मुंहासे वाली त्वचा के लिए बनाया गया है और इसे दिन में दो बार (सुबह और रात) इस्तेमाल किया जा सकता है। इसमें सल्फेट-फ्री अमीनो एसिड क्लेंज़र और Ceramide NP है, जो त्वचा को बिना सुखाए हल्के से साफ करता है।" },
               
                { question: "क्या यह सल्फेट-फ्री और पैराबेंस-फ्री है?", answer: "हाँ। Alite Anti-Acne Face Wash में SLS, SLES और पैराबेन नहीं हैं। यह साबुन-मुक्त (Soap-Free) और नॉन-कॉमेडोजेनिक है, यानी यह पोर्स को बंद नहीं करता।" }]
        },
        "51588893835576": {
            // 1. MAIN GRID IMAGE
            image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/sc.png?v=1767679341",
            
            // 2. SUPPORTIVE SECTION IMAGE (PASTE YOUR NEW LINK HERE)
            supportiveImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/small_sc.png?v=1767679341", 
             images: [
                "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/glameron.png?v=1767945956"
            ],
            title: "Glameron Face Mask",
            description: "A nourishing radiance-boosting mask designed to refresh dull, tired-looking skin. Formulated with antioxidants, botanical extracts, and hydrating agents, it helps improve skin texture and restore a healthy glow. The rich, creamy formula supports barrier comfort while delivering a spa-like experience at home.",
            quantityLabel: "2 face mask",
            price: 350,
            benefits: ["Brightens", "Revitalizes"],
          howToUse: [
    "Apply an even layer of Glameron Skin Glow Face Mask to cleansed skin, avoiding the eye area.",
    "Leave on for 10-15 minutes, then rinse off with lukewarm water.",
    "Use 2-3 times a week for best results."
],
            composition: "Purified Water, Propylene Glycol, Glycerin, Kakadu Plum Extract, Niacinamide, Vitamin E Acetate, Sodium Hyaluronate Crosspolymer, Milk Protein, Betaine, Hydroxypropyl Methylcellulose, Sodium lactate, Carbomer, Di Sodium EDTA, Sodium Hydroxide, Phenoxyethanol (and) Ethylhexylglycerin, Perfume.",
            bestSuitedFor: "सभी प्रकार की त्वचा",
            productForm: "Sheet Mask",
            areaOfApplication: "Face and Necks",
            faqs: [{ question: "What is Glameron Skin Glow Face Mask?", answer: "It is a nourishing face mask designed to brighten the complexion, refresh dull skin, and enhance the skin’s natural radiance." },
                { question: "How long does it take to see results with Glameron Skin Glow Face Mask?", answer: "Visible improvements in skin brightness and texture are typically noticed after a few applications." },
                { question: " Who can use Glameron Skin Glow Face Mask?", answer: "The mask is suitable for all skin types and is ideal for anyone looking to boost skin glow and radiance." },
                { question: " Can Glameron Skin Glow Face Mask be used with other skincare products?", answer: "Yes. It can be used alongside your regular skincare routine, and it is recommended to follow with a moisturizer for best results." }]
        },
            "51598963638584": {
            // 1. MAIN GRID IMAGE
            image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Cosderma_1.png?v=1767852624",
            
            // 2. SUPPORTIVE SECTION IMAGE (PASTE YOUR NEW LINK HERE)
            supportiveImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Cosderma.png?v=1767852565", 
images: [
                "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Cosderma_2.png?v=1767945957"
            ],
            title: "Cosderma Clear Face <br> Sheet Mask",
            description: "<strong>A clarifying sheet mask </strong> designed to manage acne, calm inflammation, and control excess oil. It helps tighten pores, regulate sebum production, and support the skin’s natural pH balance. The hydrating formula delivers moisture without heaviness, keeping skin comfortable and refreshed. Ideal as a supportive add-on for oily and acne-prone skin.",
            price:  247,
           quantityLabel: "1  face mask",
                   howToUse: [
    "Start by washing your face with a gentle cleanser and patting it dry.",
    "Open the pack and carefully unfold the sheet mask. Place it on your face, smoothing it out around the eyes, nose, and mouth",
    "Leave the mask on for 15-20 minutes, allowing your skin to absorb the serum.",
    "Gently remove the mask and discard it. Massage any remaining serum into your skin until fully absorbed."
],
            benefits: ["Prevents Acne", "Reduces Redness"],
            composition: "Collagen, Hyaluronic Acid, Cucumber Extract, Vitamin E, Pumpkin Extract, Aloe Vera Extract, Witch Hazel Extract, Niacinamide",
            bestSuitedFor: " सभी प्रकार की त्वचा",
            productForm: "Sheet Mask",
            areaOfApplication: "Face and Neck",
            faqs: [{ question: " What is Cosderma Collagen Face Sheet Mask used for?", answer: "It is formulated to help manage fine lines, wrinkles, open pores, and acne while supporting skin elasticity and hydration." },
                { question: "Can I reuse a face sheet mask?", answer: "No. Face sheet masks are designed for single use only. Reusing a mask can introduce bacteria to the skin and may lead to irritation or infection." },
                { question: "Can I use this mask if I have acne-prone skin?", answer: "Yes. The mask contains soothing and balancing ingredients such as aloe vera, cucumber extract, and niacinamide, which help calm irritation and support acne-prone skin." },
                { question: "Is the Cosderma Collagen Face Sheet Mask safe for sensitive skin", answer: "The mask is generally well tolerated, but if you experience redness, itching, or discomfort, discontinue use and consult a healthcare professional." }
            ]
        },
           "51599001846072": {
            // 1. MAIN GRID IMAGE
            image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Acnepad.png?v=1767853120",
            
            // 2. SUPPORTIVE SECTION IMAGE (PASTE YOUR NEW LINK HERE)
            supportiveImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Acnepad_1.png?v=1767853120", 
images: [
                "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Acnepad_2.png?v=1767945957"
            ],
            title: "Acnepad Salicylic Acid <br>& Glycolic Acid Wipes",
            description: "<strong>A convenient daily-care solution </strong> designed to manage acne, clogged pores, and uneven skin texture. Salicylic acid and glycolic acid work together to clear pores and gently exfoliate surface build-up. Aloe vera and chamomile help soothe irritation and reduce visible redness. Suitable for daily use when incorporated as advised into an acne-care routine.",
            price: 449,
             quantityLabel: "50 wipes",
           howToUse: [
    "Wipe the pad gently over the affected areas after cleansing.",
    "Do not rinse; allow the solution to absorb into the skin.",
    "Use once or twice daily. Follow with sunscreen during the day."
],
            benefits: ["Soothes Skin", "Unclog Pores"],
            composition: "Salicylic Acid (2% w/w) + Glycolic Acid (1% w/w)",
            bestSuitedFor: " सभी प्रकार की त्वचा",
            productForm: "Wipes",
            areaOfApplication: "Face",
            faqs: [{ question: "What are Acnepad Salicylic Acid & Glycolic Acid Wipes?", answer: "They are pre-soaked exfoliating wipes formulated to help manage acne and improve skin texture by unclogging pores and reducing breakouts." },
                { question: "How do Acnepad Salicylic Acid & Glycolic Acid Wipes work?", answer: "Salicylic acid and glycolic acid work together to clear pores, gently exfoliate surface build-up, and promote a smoother, clearer complexion, while calming ingredients help reduce irritation." },
                { question: "Who should use Acnepad Salicylic Acid & Glycolic Acid Wipes?", answer: "They are suitable for individuals looking to maintain clear, blemish-prone skin and can be used across all skin types when used as advised." },
                { question: "Can Acnepad Salicylic Acid & Glycolic Acid Wipes be used with other skincare products?", answer: "Yes. They can be easily incorporated into your regular skincare routine and used alongside other compatible skincare products." }
            ]
        },
         "51599014691128": {
            // 1. MAIN GRID IMAGE
            image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Rega_BPO_1.png?v=1767854030",
             
            // 2. SUPPORTIVE SECTION IMAGE (PASTE YOUR NEW LINK HERE)
            supportiveImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Rega_BPO.png?v=1767854030", 
images: [
                "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Rega_BPO_2.png?v=1767945956"
            ],
            title: "Rega-BPO Acne Spot <br> Corrector Gel",
            description: "A fast-acting spot corrector that targets active acne and helps prevent new breakouts. Benzoyl peroxide works deep within pores to control acne-causing bacteria. Aloe vera and allantoin support skin healing while calming irritation. Best used as a targeted add-on alongside your treatment plan.",
            price: 619,
             quantityLabel: "15gm",
           howToUse: [
    "Thoroughly clean and dry the affected area",
    "Apply a small amount of the gel directly to the pimple.",
    "Allow to absorb and dry completely before applying other skincare products or makeup.",
    "Use sunscreen during the day to protect the treated areas from sun sensitivity."
],
            benefits: ["Soothes", "Reduces Redness"],
            composition: "Purified Water, Salsphere BPO (Aqua, Benzoyl Peroxide, Hydroxyethyl Behenamidopropyl Dimonium Chloride, Butyrospermum Parkii (Shea) Butter Extract, Euphorbia Cerifera (Candelilla) Wax), Acrylamide / Sodium Acryloyldimethyltaurate Copolymer (And) Isohexadecane (And) Polysorbate 80, Propylene Dimethylamine, Salicylic Acid 1%, Water, Polysorbate 80, Glycerin, Butyrospermum Parkii (Shea Butter) Fruit, Ascorbic Acid, Benzalkonium Chloride, Camellia Sinensis Leaf Extract, Isomerized Safflower Acid, Palmitoyl Tripeptide-5, Anthemis Nobilis Flower Extract, Maltodextrin, Cera Alba, Silica, Palmitic Acid, Clay, Zinc Sulfate, Fucus Vesiculosis (Seaweed) Extract, Phenoxyethanol, Ethylhexylglycerin) Polysorbate 80, DisodiumEDTA, Fragrance, Triethanolamine.",
            bestSuitedFor: " सभी प्रकार की त्वचा",
            productForm: "Gel",
            areaOfApplication: "Face (area affected with pimples)",
            faqs: [{ question: "What is Rega-BPO Acne Spot Corrector Gel? ", answer: "It is a targeted spot treatment formulated with benzoyl peroxide to reduce active acne and help prevent future breakouts. Soothing ingredients like aloe vera and allantoin support skin healing and help calm irritation." },
                { question: "Can Rega-BPO Acne Spot Corrector Gel be used with other skincare products? ", answer: "Yes. Allow the gel to fully absorb and dry before applying other products, and pair it with gentle, non-comedogenic formulations to minimize irritation." },
                { question: "Who should use Rega-BPO Acne Spot Corrector Gel?", answer: "It is suitable for individuals experiencing occasional pimples or persistent acne who need a fast-acting, targeted solution for breakout control." }
            ]
        },
        "51599016362296": {
        // 1. MAIN GRID IMAGE
        image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Brilante_serum_1.png?v=1767855591", // REPLACE WITH ACTUAL IMAGE URL
        
        // 2. SUPPORTIVE SECTION IMAGE
        supportiveImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Brilante_serum.png?v=1767855590", // REPLACE WITH ACTUAL IMAGE URL
images: [
                "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Brilante_serum_2.png?v=1767945956"
            ],
        title: "Brilante Intense Brightening <br> Serum",
        description: "<strong>An intensive depigmenting serum </strong> formulated to target dark spots and uneven skin tone. Its high-concentration, fast-absorbing formula enables deeper penetration for quicker visible results. The serum works by inhibiting excess melanin production while supporting skin brightness and clarity. Suitable as a corrective add-on for pigmentation-prone and uneven-toned skin.",
        price: 529, // CHECK PRICE
         quantityLabel: "30ml serum",
           howToUse: [
    "Cleanse face with water or mild cleanser and gently pat dry",
    "Take 4 to 6 drops of Brilante serum and dab the serum onto your face and neck",
    "Gently massage in a circular motion until it is completely absorbed"
],
        benefits: ["Depigmenting", "Lightens Spots"],
        composition: "Purified Water, Polyacrylate-13, Polyisobutene, Polysorbate 20, Diethylene Glycol Mono ethyl ether, Alpha Arbutin, Licorice Extract 40% CA, 4-n-butylresorcinol, Allantoin, Acetylated Lanoline Alcohol, Imidazolidinyl Urea, Di Sodium EDTA, Propanediol, Benzyl Alcohol, Fragrance.",
        bestSuitedFor: "सभी प्रकार की त्वचाs",
        productForm: "Serum",
        areaOfApplication: "Face",
        faqs: [{ question: "What is Brilante Intense Brightening Serum?", answer: "It is a dermatologically tested brightening serum formulated to help reduce dark spots and support a more even skin tone." },
            { question: "How does Brilante Intense Brightening Serum work?", answer: "The high-concentration formula delivers targeted depigmenting action, helping to reduce excess pigmentation and promote a brighter, clearer complexion." },
            
            { question: " Is Brilante Intense Brightening Serum suitable for all skin types?", answer: " Yes. The serum is suitable for all skin types and is designed to support the management of dark spots and uneven skin tone." }
        ]
    },
        "52005288640824": {
            image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/naase_balance_capsule.png?v=1774706036",
            images: [
                 "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/balance_cap.png?v=1774706036",
            ],
            title: "Naase balance capsule",
            product_used: "Ayurveda",
            benefits: ["तनाव संतुलन", "मानसिक शांति"],
            description: "नींद में सुधार करता है, तनाव कम करता है, और आपकी एकाग्रता व ध्यान क्षमता को बढ़ाता है।",
            tagline: "STRESS RELIEF",
            quantityLabel: "कैप्सूल",
            price: 350,
            composition: "Each 100 mg coated tablet contains Ashwagandha (Withania somnifera) 100 mg Brahmi (Bacopa monnieri) 100 mg Shankhapushpi (Convolvulus pluricaulis) 100 mg Jatamansi Extract (Nardostachys jatamansi) 40 mg Sarpagandha (Rowvolfia sepentina) 40 mg Vacha Powder (Acorus calamus)  20 mg Talc IP (5 mg) - Magenisum Stearate IP (5 mg) - Aerosil IP (5 mg).",
            bestSuitedFor: "तनाव या नींद से जुड़ी समस्याओं का सामना कर रहे वयस्कों के लिए",
            productForm: "कैप्सूल",
            areaOfApplication: "मौखिक (Oral)",
            
            activeIngredients: [{
                name: "ब्राह्मी",
                desc: "यह एक शक्तिशाली आयुर्वेदिक जड़ी-बूटी है जो याददाश्त, ध्यान और मानसिक स्पष्टता को बढ़ाती है तथा मन को शांत करती है।",
                tags: ["फोकस और मानसिक स्पष्टता", "तनाव कम करना"],
                bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Brahmi.png?v=1765353768"
            },
            {
                name: "जटामांसी",
                desc: "यह एक शांतिदायक जड़ी-बूटी है जो तनाव को कम करती है, मूड को स्थिर करती है और अच्छी नींद में मदद करती है।",
                tags: ["तनाव से राहत", "बेहतर नींद"],
                bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Jatamansi.png?v=1765353768"
            },
            {
                name: "अश्वगंधा",
                desc: "यह एक शक्तिशाली जड़ है जो शरीर को तनाव से निपटने में मदद करती है और ऊर्जा व ताकत बढ़ाती है।",
                tags: ["तनाव और चिंता कम करना", "ऊर्जा और सहनशक्ति बढ़ाना"],
                bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Ashwagandha.png?v=1774706038"
            }],
            faqs: [
                { question: "नासे बैलेंस कैप्सूल किस काम आता है?", answer: "यह कैप्सूल तनाव को कम करने, मानसिक शांति बढ़ाने और नर्वस सिस्टम को संतुलित करने के लिए बनाया गया है। इसमें अश्वगंधा, ब्राह्मी, जटामांसी और शंखपुष्पी जैसी जड़ी-बूटियां होती हैं जो मन को शांत और संतुलित बनाती हैं।" },
                { question: " इसका असर कितने समय में दिखता है?", answer: "अधिकांश लोगों को 2–4 हफ्तों में तनाव में कमी, शांति और नींद की गुणवत्ता में सुधार महसूस होता है। परिणाम व्यक्ति की जीवनशैली और शरीर की प्रकृति पर निर्भर कर सकते हैं।" },
                { question: "क्या यह नींद या सुस्ती लाता है? ", answer: "नहीं, यह कोई सिडेटिव (नींद लाने वाली दवा) नहीं है। यह प्राकृतिक रूप से मन को शांत करता है और दिन में सुस्ती नहीं लाता।" },
                { question: "इसे कैसे लेना चाहिए?", answer: "रोज़ सुबह 2 कैप्सूल लें या डॉक्टर की सलाह अनुसार लें। इसे खाली पेट लेना बेहतर होता है और गुनगुने पानी या दूध के साथ लेना अधिक लाभकारी होता है।" }
            ]
        },
          "51333498437944": {
        image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/T-Detozyl.png?v=1765783776",
        images: [
          "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Detozyl.png?v=1765783675",
          
        ],
        title: "Detozyl",
        product_used: "Ayurveda",
        description: "यह शरीर से विषाक्त पदार्थों को बाहर निकालता है, पाचन में सुधार करता है और पेट फूलने व एसिडिटी को कम करता है।",
        tagline: "IMPROVE DIGESTION",
        benefits: ["आंतों का डिटॉक्स", "पाचन तंत्र की सफाई"],
        price: 426,
        composition: "Each 550 mg coated tablet contains Bahava Magaj (Cassia fistula) 100 mg, Haritaki (Terminalia chebula) 200 mg, Nishottar Ghana (Ipomoea turpethum) 100 mg, Triphala Churna (generic preparation) 100 mg, and Trikatu Ghana (generic preparation) 50 mg. Bhavana Dravya: Pippali (Piper longum) qs and excipients qs.",
        bestSuitedFor: "पाचन संबंधी समस्याएं, पेट फूलना और एसिडिटी।",
        productForm: "टॅब्लेट",
        areaOfApplication: " मौखिक (Oral)",
        
        // --- UPDATE THIS IMAGE URL ---
     

        activeIngredients: [  {
            name: " त्रिफला",
            desc: "अमलकी, बिभीतकी और हरीतकी का एक पारंपरिक मिश्रण जो धीरे-धीरे पाचन तंत्र को साफ करता है और स्वस्थ मलत्याग में मदद करता है।",
            tags: ["विषाक्तीकरण", "पाचन की नियमितता"],
            bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Triphala.png?v=1765358052"
          },
          {
            name: "त्रिकटु",
            desc: "अदरक, काली मिर्च और पीपली का एक संयोजन जो पाचन को बढ़ाता है और पोषक तत्वों के अवशोषण में सुधार करता है।",
            tags: [" पाचन में सुधार", "मेटाबॉलिज्म बढ़ाना"],
            bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/trikatu.png?v=1765358052"
          },
          {
            name: "त्वरित",
            desc: "एक प्राकृतिक रेचक जड़ी-बूटी जो आंतों को साफ करती है और जठरांत्र संबंधी मार्ग (GI tract) के गहरे शुद्धिकरण में मदद करती है।",
            tags: ["कोलन की सफाई", "शरीर की गंदगी हटाना"],
            bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Trivrit.png?v=1765358052"
          }],
        faqs: [
          { question: "डिटोज़िल (Detozyl) का उपयोग किस लिए किया जाता है?", answer: "> डिटोज़िल (Detozyl) को प्राकृतिक विषहरण (detoxification) में सहायता करने, स्वस्थ पाचन को बढ़ावा देने और शरीर से विषाक्त पदार्थों (आम) को बाहर निकालने में मदद करने के लिए तैयार किया गया है। यह नियमित मलत्याग और पेट के समग्र स्वास्थ्य का भी समर्थन करता है।" },
          { question: "मुझे डिटोज़िल (Detozyl) कैसे लेना चाहिए?", answer: "सोने के समय 1 गोली गुनगुने पानी के साथ लें, या अपने चिकित्सक द्वारा बताए अनुसार लें। बेहतर परिणामों के लिए इसका नियमित उपयोग करें।" },
          { question: "परिणाम दिखने में कितना समय लगता है?", answer: "कई उपयोगकर्ताओं को 1-2 हफ्तों के भीतर बेहतर पाचन और हल्के व साफ मलत्याग का अनुभव होता है। हालांकि, परिणाम जीवनशैली, आहार और शरीर के प्रकार (दोष) के आधार पर भिन्न हो सकते हैं।" },
          { question: " क्या इसके कोई दुष्प्रभाव (side effects) हैं?", answer: "डिटोज़िल (Detozyl) आमतौर पर अच्छी तरह से सहन किया जाता है। चूंकि यह प्राकृतिक सफाई में सहायता करता है, इसलिए कुछ उपयोगकर्ताओं को शुरुआत में मलत्याग में थोड़ी वृद्धि महसूस हो सकती है। यदि परेशानी बनी रहती है, तो खुराक कम करें या अपने चिकित्सक से परामर्श करें।" }
        ]
      },
        "52005279859000": {
            image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/gut_health_powder.png?v=1774706036",
            images: [
                "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/gut_health_8.png?v=1774706036",
            ],
            title: "Naase gut health powder",
            benefits: ["आंतों का डिटॉक्स", "पाचन तंत्र की सफाई"],
            product_used: "Ayurveda",
            description: "शरीर से विषैले तत्वों को बाहर निकालता है, पाचन सुधारता है, और पेट फूलना व एसिडिटी को कम करता है।",
            tagline: "IMPROVE DIGESTION",
            price:  350,
             quantityLabel: "120 ग्राम",
            composition: "Each 100 mg coated tablet contains Sunthi (Zingiber officinale) 758 mg Miri (Piper Nigrum) 758 mg Pippali (Piper lingum) 758 mg Haritaki (Terminalia chebula) 758 mg Vibhitaki (Terminalia belerica) 758 mg Amalaki (Embelica officinalis) 758 mg Bid Lavan (Vida salt) 758 mg Choti Elaichi (Elettaria cardamomum) 758 mg Tamalpatra (Cinnamomum tamala) 758 mg Vidang (Embelia ribes) 758 mg Musta (Cyperus rotundus) 758 mg Lavang (Syzygium aromaticum) 8.33 mg Trivrit (Operculina turpethum) 33.33 mg Sharkara (50 gm).",
            bestSuitedFor: "उपयुक्त है: पाचन संबंधी समस्याएं, पेट फूलना और एसिडिटी के लिए",
            productForm: "पाउडर",
            areaOfApplication: "मौखिक (Oral)",
            
            activeIngredients: [  {
                name: "त्रिफला",
                desc: "यह आंवला, विभीतकी और हरितकी का पारंपरिक मिश्रण है, जो पाचन तंत्र को साफ करता है और मल त्याग को नियमित बनाता है।",
                tags: ["शरीर से विषैले तत्व (डिटॉक्स) निकालना", "पाचन को नियमित करना"],
                bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Triphala.png?v=1765358052"
            },
            {
                name: "त्रिवृत",
                desc: "यह एक प्राकृतिक रेचक (laxative) है जो आंतों को साफ करता है और गहरे स्तर पर डिटॉक्स में मदद करता है।",
                tags: ["कोलन की सफाई", "विषैले तत्वों को निकालना"],
                bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/trikatu.png?v=1765358052"
            },
            {
                name: "शर्करा",
                desc: "यह प्राकृतिक शर्करा है जो शरीर को ठंडक देती है और पाचन में मदद करती है।",
                tags: ["शरीर को ठंडक देना", "पाचन में सहायता"],
                bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/sharkara.png?v=1774706038"
            }],
            faqs: [
                { question: "नासे गट हेल्थ पाउडर किस काम आता है?", answer: "यह पाउडर शरीर की प्राकृतिक डिटॉक्स प्रक्रिया को सपोर्ट करता है, पाचन को बेहतर बनाता है और शरीर से विषैले तत्व (आम) निकालने में मदद करता है। साथ ही यह नियमित मल त्याग और संपूर्ण गट हेल्थ को सुधारता है।" },
                { question: " इसे कैसे लेना चाहिए?", answer: "रात को सोने से पहले 1 टेबलस्पून पाउडर गुनगुने पानी के साथ लें या डॉक्टर के निर्देश अनुसार सेवन करें।" },
                { question: "परिणाम कितने समय में दिखते हैं?", answer: "कई लोगों को 1–2 हफ्तों में पाचन में सुधार और साफ मल त्याग का अनुभव होता है। हालांकि, परिणाम व्यक्ति की जीवनशैली, आहार और शरीर की प्रकृति (दोष) पर निर्भर करते हैं।" },
                { question: " क्या इसके कोई साइड इफेक्ट्स हैं?", answer: "यह सामान्यतः सुरक्षित है। शुरुआत में कुछ लोगों को मल त्याग थोड़ा बढ़ा हुआ महसूस हो सकता है क्योंकि यह शरीर को साफ करता है। यदि कोई असुविधा हो तो मात्रा कम करें या डॉक्टर से सलाह लें।" }
            ]
        },
        "49547577426232": {
            image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Dermat_sunscreen.png?v=1765366771",
            images: [
                "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/sunscreen_1.png?v=1765354366",
            ],
            title: "Acnetrol Sunscreen",
            product_used: "Dermatology",
            benefits: ["UV protection", "Breakout safe"],
            description: "Clinderma Acnetrol UV Sunscreen is designed to protect, hydrate, and soothe the skin without clogging pores or causing breakouts.",
            tagline: "PROTECTIVE",
            price: 550,
             quantityLabel: "50 gm ",
            composition: "Octinoxate, Uvinul A, Tinosorb M, Tinosorb S, Zinc Oxide, Zinc PCA, Sodium Hyaluronate, LLP, Carbopol, Cetostearyl Alcohol, CM 1000, Stearic Acid, Glyceryl Monostearate NSE, Propylene Glycol, Glycerine, Disodium EDTA, BRB SG 210, Sweet Orange Oil, Vitamin E, BHT, Water",
            bestSuitedFor:  " सभी प्रकार की त्वचा",
            productForm: "Cream",
            areaOfApplication: "Face",
            
            clinicalImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Clinical_studies_content-sunsccreen.png?v=1763721892",

            activeIngredients: [
                {
                    name: "Tinosorb S • Tinosorb M • Uvinul A :",
                    desc: "High-efficiency UVA/UVB filters that deliver superior photostability and long-lasting sun protection.",
                    tags: ["Broad-spectrum UV defense", " Preventing tanning & photo-aging"],
                    bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Tinosorb-S1.png?v=1765353269"
                },
                {
                    name: "Octinoxate + Zinc Oxide :",
                    desc: "A balanced blend of chemical and mineral filters that enhances overall sun protection",
                    tags: ["UV protection ", "Environmental defense"],
                    bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Octinoxate_Zinc_Oxide.png?v=1765353361"
                },
                {
                    name: "Vitamin E (Tocopherol):",
                    desc: "Enhances sunscreen effectiveness, deeply hydrates, and protects the skin.",
                    tags: ["Supports skin repair ", "Improves texture"],
                    bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/vitamin_E.png?v=1765353408"
                },
                {
                    name: "Zinc PCA:",
                    desc: "Ideal for oily or acne-prone skin, helps control oil production, and soothes irritation.",
                    tags: ["Sebum-balancing ", "Acne soothing"],
                    bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Zinc_PCA_1.jpg?v=1765353441"
                },
                {
                    name: "Sodium Hyaluronate (Hyaluronic Acid)",
                    desc: "Reduces signs of photoaging and boosts sun protection efficacy.",
                    tags: ["Hydration", "Anti-aging"],
                    bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Sodium_Hyaluronate.png?v=1765353485"
                }
            ],
            faqs: [
                { question: "What skin types is Acnetrol sunscreen suitable for?", answer: "Acnetrol Sunscreen is formulated for all skin types, including sensitive and acne-prone skin, ensuring effective protection without irritation." },
                { question: "How should I apply the sunscreen?", answer: "Dispense the desired amount of sunscreen gel onto your fingertips and apply it evenly to a clean face andany exposed areas. Be sure to apply it at least 15 minutes before sun exposure to allow proper absorption." },
                { question: "How often should I use Acnetrol sunscreen?", answer: "For optimal protection, apply Acnetrol Sunscreen generously in the morning and reapply every two hours, especially during prolonged sun exposure or before swimming or sweating." },
                { question: "Does Acnetrol sunscreen leave a white cast on the skin?", answer: "No, Acnetrol UV Sunscreen features a light weight formulation that absorbs quickly into the skin, ensuring no white cast is left behind, making it ideal for daily wear under makeup or alone." }
            ]
        },
        "49540457005368": {
            image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/acnetrol_cleanser.png?v=1761558623",
            images: [
                "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Acnetrol_cleanser_1.png?v=1765354246",
            ],
            title: "Acnetrol Cleanser",
            product_used: "Dermatology",
            benefits: ["साफ़ करें", "रोमछिद्रों को खोलें"],
            description: "क्लिंडर्मा एकनेट्रोल क्लेंज़र, जिसमें सैलिसिलिक एसिड, नियासिनामाइड और जिंक PCA शामिल हैं, त्वचा के रोमछिद्रों (पोर्स) को गहराई से साफ करता है, अतिरिक्त तेल हटाता है और ब्लैकहेड्स, व्हाइटहेड्स तथा मुंहासों को कम करने में मदद करता है।",
            tagline: "CLEANSER",
            price:  380,
             quantityLabel: "100 मिली",
            composition: "सैलिसिलिक एसिड, जिंक PCA, टी ट्री ऑयल, नियासिनामाइड, एलोवेरा एक्सट्रैक्ट, कोको ग्लूकोसाइड, ग्लिसरीन, कार्बोपोल, HPMC, बेंज़िल अल्कोहल, पानी (एक्वा)",
            bestSuitedFor: " सभी प्रकार की त्वचा",
            productForm: "क्लेंज़िंग जेल",
            areaOfApplication: "चेहरा",
            
            clinicalImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Acnetrol_cleanser_Clinical_studies_content.png?v=1775301262",

            activeIngredients: [
                {
                    name: "सैलिसिलिक एसिड",
                    desc: "यह एक शक्तिशाली एक्सफोलिएंट है जो पोर्स को साफ करता है और मृत त्वचा कोशिकाओं व अतिरिक्त तेल को हटाकर मुंहासों को रोकने में मदद करता है।",
                    tags: ["पोर्स खोलता है", "मुंहासे कम करता है"],
                    bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Salicylic_acid_be6a7c92-3b08-468c-88e2-d23d93e1f786.png?v=1765354247"
                },
                {
                    name: "नियासिनामाइड",
                    desc: "यह त्वचा की रंगत को समान बनाता है और पोर्स को छोटा दिखाने में मदद करता है, जिससे त्वचा की बनावट बेहतर होती है।",
                    tags: ["त्वचा को निखारता है", "टेक्सचर सुधारता है"],
                    bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Niacinamide_556aaf92-b1cd-41b4-9f07-ac8cb3bc84be.png?v=1765354246"
                },
                {
                    name: "जिंक PCA",
                    desc: "यह अतिरिक्त तेल को नियंत्रित करता है और त्वचा को शांत (सूदिंग) करता है।",
                    tags: ["ऑयल कंट्रोल", "त्वचा को शांत करना"],
                    bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Zinc_PCA_2.jpg?v=1765354246"
                }
            ],
            faqs: [
                { question: "यह क्लेंज़र किस प्रकार की त्वचा के लिए उपयुक्त है?", answer: "यह सभी प्रकार की त्वचा के लिए उपयुक्त है। बेहतर परिणाम के लिए इसे दिन में दो बार—सुबह और शाम—उपयोग करें।" },
                { question: "परिणाम देखने में कितना समय लगता है?", answer: "लगातार उपयोग के कुछ हफ्तों में त्वचा साफ और मुंहासों में कमी दिखाई दे सकती है, हालांकि परिणाम व्यक्ति के अनुसार अलग हो सकते हैं।" },
                { question: "क्या इसके कोई साइड इफेक्ट्स हैं?", answer: "यह आमतौर पर सुरक्षित है, लेकिन संवेदनशील त्वचा में हल्का सूखापन या लालिमा हो सकती है। यदि समस्या बनी रहे तो उपयोग बंद करें और डॉक्टर से सलाह लें।" },
                { question: "इसे कैसे इस्तेमाल करें?", answer: "गीली त्वचा पर क्लेंज़र लगाएं और हल्के हाथों से गोलाकार गति में मसाज करें ताकि गंदगी और तेल हट जाए। फिर पानी से अच्छी तरह धो लें।" },
                { question: "क्या यह मुंहासों में मदद करता है?", answer: "हाँ, यह क्लेंज़र खास तौर पर मुंहासों को कम करने के लिए बनाया गया है। यह अतिरिक्त तेल हटाता है, पोर्स को साफ रखता है और सूजन कम करता है।" }
            ]
        },

        // --- EPIFADE CREAM (Updated with Active Ingredients) ---
        "49582377959736": {
            image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/epifade_dermat.png?v=1763703212",
            images: [
                "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Epifade_2.png?v=1765358597",
            
            ],
            title: "Epifade Cream",
            benefits: ["दाग-धब्बों को हल्का करना", "मुंहासों के निशान"],
            product_used: "Dermatology",
            description: "ग्लाइकोलिक एसिड, आर्बुटिन और कोजिक एसिड डिपाल्मिटेट युक्त एपिफेड क्रीम मुंहासों के बाद के निशान (पोस्ट-एक्ने मार्क्स) और पिग्मेंटेशन को कम करने में मदद करती है। यह त्वचा को धीरे-धीरे एक्सफोलिएट करती है, डार्क स्पॉट्स को हल्का करती है और त्वचा की रंगत को निखारकर उसे अधिक समान और चमकदार बनाती है।",
            tagline: "DEPIGMENTATION",
            price: 425,
             quantityLabel: "20 ग्राम",
            composition: "Glycolic acid, Arbutin, Kojic acid dipalmitate creams",
            bestSuitedFor: ": वयस्क और किशोर जिनको मुंहासों के निशान या हाइपरपिग्मेंटेशन है|",
            productForm: "जेल",
            areaOfApplication: "चेहरा (जहां पिग्मेंटेशन, डार्क स्पॉट्स, मुंहासों के निशान या असमान स्किन टोन हो)",
            
            clinicalImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/epifade_Clinical_studies_content.png?v=1775301260",

            activeIngredients: [
                {
                    name: "ग्लाइकोलिक एसिड",
                    desc: "यह पिग्मेंटेशन को कम करता है, जो मुंहासों वाली त्वचा में स्किन टोन को समान बनाने के लिए महत्वपूर्ण है।",
                    tags: ["एक्सफोलिएशन", "त्वचा की बनावट में सुधार"],
                    bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Glycolic_Acid_1.png?v=1765199724"
                },
                {
                    name: "आर्बुटिन:",
                    desc: "यह मुंहासों के कारण बने डार्क स्पॉट्स को हल्का करने में मदद करता है और बिना जलन के त्वचा को समान बनाता है।",
                    tags: ["डार्क स्पॉट कम करना", "त्वचा को चमकदार बनाना"],
                    bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Arbutin_1.png?v=1765199724"
                },
                {
                    name: "कोजिक एसिड डिपाल्मिटेट",
                    desc: "यह पिग्मेंटेशन को नियंत्रित करता है और लंबे समय तक सुरक्षित रूप से त्वचा को हल्का करने में मदद करता है।",
                    tags: ["पिग्मेंटेशन नियंत्रण", "समान त्वचा टोन"],
                    bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Kojic_acid_043d0c70-0c99-44f6-a771-c9fbdc084e1b.png?v=1765199724"
                }
            ],
            faqs: [
                { question: "इसके संभावित साइड इफेक्ट्स क्या हैं?", answer: "हल्की त्वचा में जलन, लालिमा, सूखापन और पीलिंग हो सकती है। ये आमतौर पर अस्थायी होते हैं और क्रीम बंद करने पर ठीक हो जाते हैं। यदि समस्या बढ़े तो डॉक्टर से संपर्क करें।" },
                { question: "साइड इफेक्ट्स को कैसे मैनेज करें?", answer: "यहाँ कुछ टिप्स दिए गए हैं:  <strong> हल्की जलन</strong>- क्रीम को रात में लगाएं ताकि त्वचा को आराम मिले <strong>सूखापन</strong>- सुबह हल्का मॉइस्चराइज़र लगाएं" },
                { question: "इसे कैसे इस्तेमाल करें?", answer: "साफ और सूखी त्वचा पर प्रभावित जगह पर पतली परत लगाएं, दिन में 1–2 बार या डॉक्टर के निर्देशानुसार। धीरे-धीरे मसाज करें जब तक पूरी तरह अवशोषित न हो जाए। दिन में SPF 30 या उससे अधिक सनस्क्रीन जरूर लगाएं क्योंकि यह त्वचा को धूप के प्रति संवेदनशील बना सकती है।" },
                { question: " क्या यह त्वचा को गोरा करता है?", answer: "यह क्रीम त्वचा में मेलेनिन के उत्पादन को कम करके हाइपरपिग्मेंटेशन घटाती है, जिससे त्वचा हल्की और समान दिखती है। उपयोग से पहले डॉक्टर से सलाह लें।" },
                { question: "क्या कोई सावधानियां हैं?", answer: "हाँ, इसे अन्य पिग्मेंटेशन कम करने या पीलिंग ट्रीटमेंट के साथ न मिलाएं, इससे जलन बढ़ सकती है। 18 साल से कम उम्र, गर्भवती या स्तनपान कराने वाली महिलाओं को बिना डॉक्टर की सलाह के उपयोग नहीं करना चाहिए।" },
                { question: "किन लोगों को इसका उपयोग नहीं करना चाहिए?", answer: "यदि आपको इसके किसी भी घटक से एलर्जी है तो इसका उपयोग न करें। शुरू करने से पहले डॉक्टर से सलाह लें।" }
            ]
        },

        "50944516981048": {
            // 1. MAIN GRID IMAGE
            image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Salisia_KT_2.png?v=1767853981",
            
            // 2. SUPPORTIVE SECTION IMAGE (PASTE YOUR NEW LINK HERE)
            supportiveImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Salisia_KT_3.png?v=1767853981",

            images: [
                "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Salisia_KT_3.png?v=1767853981",
            ],
            title: "Salisia KT shampoo", 
            product_used: "Dermatology",
            description: "सालिसिया केटी शैम्पू एक टॉपिकल ट्रीटमेंट है जो खासतौर पर डैंड्रफ (रूसी) को नियंत्रित करने और स्कैल्प की सेहत सुधारने के लिए बनाया गया है। इसमें केटोकोनाज़ोल और सैलिसिलिक एसिड का संयोजन होता है, जो मिलकर डैंड्रफ के मुख्य कारणों को खत्म करने में मदद करते हैं।",
            tagline: "CONTROL DANDRUFF",
            price: 299,
               quantityLabel: "75.0ml",
           howToUse: [
   "गीले बालों और स्कैल्प पर पर्याप्त मात्रा में शैम्पू लगाएं। हल्के हाथों से मसाज करें ताकि अच्छा झाग बन जाए।",
"इसे 5 मिनट तक लगा रहने दें।",
"फिर गुनगुने पानी से बालों और स्कैल्प को अच्छी तरह धो लें और सामान्य तरीके से सुखाएं।"
],
            benefits: ["Anti-Dandruff", "Itch Relief"],
            composition: "सैलिसिलिक एसिड (2.0% w/v) +केटोकोनाज़ोल (2.0% w/v)",
            bestSuitedFor: " डैंड्रफ के उपचार के लिए",
            productForm: "सॉल्यूशन",
            areaOfApplication: "Scalp",
            
            activeIngredients: [ {
                name: "केटोकोनाज़ोल",
                desc: "यह एक एंटीफंगल एजेंट है जो डैंड्रफ पैदा करने वाले फंगस को खत्म करता है और उनकी वृद्धि को रोकता है। यह स्कैल्प की जलन और रूसी को कम करता है।",
                tags: ["फंगल नियंत्रण", " डैंड्रफ में कमी"],
                bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Ketoconazole.png?v=1765367247"
            },
            {
                name: "सैलिसिलिक एसिड",
                desc: "यह एक केराटोलिटिक एजेंट है जो स्कैल्प की मृत और जमी हुई त्वचा को नरम कर हटाता है। इससे फ्लेक्स, स्केल्स और बिल्डअप हटते हैं और खुजली से राहत मिलती है।",
                tags: [" रूसी (फ्लेक्स) हटाना", "खुजली से राहत"],
                bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Salicylic_acid_1_b468e68b-ef1c-4f61-8e21-842a9775968e.png?v=1765364081"
            }],
            faqs: [
                { question: "यह शैम्पू किन समस्याओं में मदद करता है?", answer: "यह डैंड्रफ, खुजली वाली स्कैल्प और सेबोरहाइक डर्मेटाइटिस में उपयोगी है। यह फ्लेकिंग, लालिमा और जलन को कम करता है।" },
                {
                    question: "इसके साइड इफेक्ट्स क्या हो सकते हैं?",
                    answer: "अधिकांश लोग इसे आसानी से सहन कर लेते हैं, लेकिन कुछ लोगों को हल्की जलन, खुजली या लालिमा हो सकती है। ये आमतौर पर अस्थायी होते हैं और समय के साथ ठीक हो जाते हैं। यदि समस्या बनी रहे या बढ़े तो डॉक्टर से सलाह लें।"
                },
                { question: " इसे कैसे इस्तेमाल करें?", answer: "डॉक्टर के निर्देशानुसार उपयोग करें। बाल और स्कैल्प को गीला करें, शैम्पू लगाकर अच्छी तरह झाग बनाएं और फिर धो लें। आंखों में जाने से बचाएं—अगर चला जाए तो तुरंत पानी से धो लें।" }
            ]
        },
        "50976651510072": {
            image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/ointment_and_oral.png?v=1761558622",
            images: [
                "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/ointment_and_oral.png?v=1761558622",
            ],
            title: "Ointment and Oral <br> Medicine",
            product_used: "Dermatology",
            description: "ये मुंहासों के इलाज के लिए प्रिस्क्रिप्शन दवाइयाँ हैं। मेडिकल गाइडलाइन्स के अनुसार, इनके सटीक नाम केवल त्वचा विशेषज्ञ की अनुमति के बाद ही साझा किए जा सकते हैं। उपचार शुरू करने के बाद, आपको सभी दवाओं के नाम और उनकी खुराक (डोज़) के साथ पूरा प्रिस्क्रिप्शन दिया जाएगा।",
           
            price: 570,
        },
        "51309381157176": {
            image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Dermat_Aquasoft_FC.png?v=1765366770",
            images: [
                "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/aquasoft.png?v=1765357979",
            ],
            title: "Aquasoft FC Advanced <BR> Facial Cream",
            benefits: ["Barrier repair", "Skin hydration"],
            product_used: "Dermatology",
            description: "Aquasoft FC Advanced Facial Cream is a lightweight, fast-absorbing moisturizer formulated for sensitive and oily skin. It hydrates deeply, soothes redness and irritation, and helps heal minor cuts, burns, and blemishes while strengthening the skin’s barrier. Non-greasy and non-comedogenic, it leaves the skin soft and protected, making it suitable for daily use with added UV protection to prevent further damage.",
            tagline: "TREATS",
              quantityLabel: "60 gm",
            price: 293,
            composition: "Purified Water, Medium-chain Triglycerides, Cyclopentasiloxane, Cyclomethicone, Cetosteary/ Alcohol C 13,15 Alkane Glyceryl Monostearate Sorbitan Stearate, Dimethicone, Xylityglucoside, PEG, 100 Stearate, Stearic Acid, Vitamin E Acetate, Phenoxyethanol Anhydroxylitol, Xylitol, Polyacrylate 13, Dimethicone Crosspolymer, Polyisobutene Glucose Dimethiconol, Ceteary| Glucoside, Diethytamino Hydroxybenzoy| Hexyl Benzoate, Ethylhexy/ Triazone, BisEthylnexyloxyphenolMethoxyphenyl Trazine, Fragrance, Disodium EDTA, Ethylnexyiglycerin, Acacia Senegal Gum, Xanthan Gum, Sodium Hydroxide, Polysorbate 20, Sorbitan Isostearate, Pheny/ Trimethicone, C12-15 Ally/ Benzoate.",
            bestSuitedFor: "सभी प्रकार की त्वचा",
            productForm: "Cream",
            areaOfApplication: "Face",
            
            activeIngredients: [
                {
                    name: "Diethylamino Hydroxybenzoyl Hexyl Benzoate (Uvinul A Plus)",
                    desc: "A high-performance UVA filter that protects against long-wave UVA rays and remains highly photostable.",
                    tags: ["UVA protection", "anti aging protection"],
                    bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Diethylamino_desktop.png?v=1765354742"
                },
                {
                    name: "Ethylhexyl Triazone (Uvinul T150)",
                    desc: "A powerful UVB filter known for delivering very high SPF with minimal concentration.",
                    tags: ["Strong UVB protection", "Achieving high SPF levels"],
                    bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Uvinul_T150..png?v=1765354727"
                },
                {
                    name: "Bis-Ethylhexyloxyphenol Methoxyphenyl Triazine (Tinosorb S)",
                    desc: "An advanced broad-spectrum filter providing UVA + UVB protection with excellent stability.",
                    tags: ["Broad-spectrum defense", "Enhanced photostability & long wear"],
                    bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Tinosorb-S1_1.png?v=1765354727"
                },
                {
                    name: "Tocopheryl Acetate (Vitamin E)",
                    desc: "A potent antioxidant that protects the skin barrier while reducing UV-induced damage.",
                    tags: ["Strengthening the skin barrier", "Reducing free-radical & UV damage"],
                    bgImage: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/vitamin_E_1.png?v=1765354727"
                }
            ],
            faqs: [
                { question: "What is Aquasoft FC Advanced Facial Cream?", answer: "Aquasoft FC Advanced Facial Cream is a hydrating formula that enhances the skin’s natural glow and provides protection against both UV-A and UV-B rays." },
                { question: "How does Aquasoft FC Advanced Facial Cream work?", answer: "It penetrates deeply to moisturize, brighten, and improve skin texture while forming a protective barrier. The added UV filters shield the skin from sun damage and help maintain smoothness." },
                { question: "Can Aquasoft FC Advanced Facial Cream protect against sun damage?", answer: "Yes, the cream includes sunscreen ingredients that defend the skin from harmful UV-A and UV-B rays." },
                { question: "Is Aquasoft FC Advanced Facial Cream suitable for all skin types?", answer: "Aquasoft FC Advanced Facial Cream is suited for dry skin, but it can also be used by individuals with oily skin." }
            ]
        },
        "50976650559800": {
            image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/topical_ointment.png?v=1761558622",
            images: [
                "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/topical_ointment.png?v=1761558622",
            ],
            title: "Topical Ointment",
            product_used: "Dermatology",
            description: "ये मुंहासों के इलाज के लिए प्रिस्क्रिप्शन दवाइयाँ हैं। मेडिकल गाइडलाइन्स के अनुसार, इनके सटीक नाम केवल त्वचा विशेषज्ञ की अनुमति के बाद ही साझा किए जा सकते हैं। उपचार शुरू करने के बाद, आपको सभी दवाओं के नाम और उनकी खुराक (डोज़) के साथ पूरा प्रिस्क्रिप्शन दिया जाएगा।",
            tagline: "TREATS",
            
            price: 270,
        },
        "51802871431480": {
            image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Aquasoftdaycream.png?v=1771240064",
            images: [
                "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Aquasoft-sunscreen.png?v=1771239897",
            ],
            title: "Aquasoft Day Cream",
             quantityLabel: "75 ग्राम",
            product_used: "Dermatology",
            description: "एक्वासॉफ्ट डे क्रीम आपकी त्वचा को हानिकारक UV किरणों और पर्यावरणीय नुकसान से बचाती है, साथ ही इसे हाइड्रेटेड और चमकदार बनाए रखती है। इसमें एडवांस सनस्क्रीन टेक्नोलॉजी और पोषक तत्व शामिल हैं, जो सभी प्रकार की त्वचा के लिए हल्का और रोज़ाना उपयोग के लिए उपयुक्त फॉर्मूला प्रदान करते हैं|",
            tagline: "TREATS",
             benefits: ["यूवी सुरक्षा", "गहन नमी प्रदान करना"],
              composition: "Purified Water, Isononyl Isononanoate, Medium-chain Triglycerides, Isopropyl Myristate, Cetostearyl Alcohol, Ethyl Oleate, Dimethicone, Shea Butter, Ceteareth-20, Steareth-21, Phenoxyethanol, Glycerin, Polysilicone-11, Butylene Glycol, Hydroxyethyl Acrylate/Sodium Acryloyldimethyltaurate Copolymer, Fragrance, Polysorbate 40, Ethylhexylglycerin, Disodium Edetate, Sorbitan isostearate, Polysorbate 60.",
            bestSuitedFor: "सभी प्रकार की त्वचा",
            productForm: "क्रीम",
            areaOfApplication: "चेहरा",
            price: 836,
              faqs: [
                { question: " एक्वासॉफ्ट डे एडवांस हाइड्रेशन क्रीम SPF 50+ PA+++ क्या है?", answer: "यह एक मल्टी-फंक्शनल डे क्रीम है जो गहरी नमी के साथ-साथ SPF 50+ PA+++ के जरिए ब्रॉड-स्पेक्ट्रम सन प्रोटेक्शन देती है।" },
                { question: "क्या यह सेंसिटिव स्किन के लिए सुरक्षित है?", answer: "हाँ, यह नॉन-कॉमेडोजेनिक है और इसमें कठोर केमिकल्स नहीं हैं, इसलिए यह संवेदनशील त्वचा के लिए भी उपयुक्त है।" },
                { question: "क्या यह व्हाइट कास्ट छोड़ती है?", answer: "नहीं, इसका हल्का फॉर्मूला त्वचा में जल्दी अवशोषित हो जाता है और कोई सफेद परत (व्हाइट कास्ट) नहीं छोड़ता।" }
            ]
        },
        // Add these inside the allProductInfo object
"51219366641976": {
    image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/10_dermat.png?v=1772600713",
     images: ["https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Aziderm10_card.png?v=1772600712"],
    title: "Aziderm 10% Gel",
    quantityLabel: "15 gm",
    price: 283,
    benefits: ["मुंहासे कम करें", "दाग-धब्बे हल्के करें"],
    description: "Aziderm 10% Gel, जिसमें अज़ेलाइक एसिड होता है, मुंहासों के इलाज में मदद करता है। यह रोमछिद्रों (pores) को खोलता है और व्हाइटहेड्स, ब्लैकहेड्स व पिंपल्स को कम करता है। यह हल्के से मध्यम रोज़ेशिया में भी लालिमा और दानों को शांत करके त्वचा को अधिक साफ़ और स्वस्थ दिखाने में मदद करता है।",
    composition: "Azelaic Acid (10% w/w)",
    bestSuitedFor: "सभी प्रकार की त्वचा",
    productForm: "जेल",
    areaOfApplication: "चेहरा",
    faqs: [
        { question: " Aziderm 10% Gel का उपयोग किसे करना चाहिए?", answer: " यह जेल उन लोगों के लिए उपयुक्त है जिनकी त्वचा मुंहासों से प्रभावित है और जो ब्रेकआउट्स, सूजन और मुंहासे पैदा करने वाले बैक्टीरिया को कम करना चाहते हैं।" },
        { question: " Aziderm 10% Gel के क्या फायदे हैं?", answer: " यह बैक्टीरिया को कम करके और सूजन को शांत करके मुंहासों से लड़ने में मदद करता है, जिससे नियमित उपयोग के साथ त्वचा अधिक साफ़ और स्वस्थ दिखती है।" },
        { question: "क्या Aziderm 10% Gel के कोई साइड इफेक्ट्स हैं?", answer: "कुछ लोगों को हल्की जलन या संवेदनशीलता हो सकती है। यदि असुविधा बनी रहती है, तो डॉक्टर से सलाह लेना बेहतर है।" }
    ]
},
"51219366740280": {
    image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/20_dermat.png?v=1772600713",
    images: ["https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Aziderm20_card.png?v=1772600713"],
    title: "Aziderm 20% Gel",
    quantityLabel: "15 gm",
    price: 328,
    benefits: ["Reduce Acne", "Lighten spots"],
    description: "Aziderm 10% Cream is a dermatologist-recommended treatment for acne, pigmentation, and rosacea. With 10% micronized azelaic acid, it unclogs pores, reduces inflammation, controls excess oil, and fades acne marks and dark spots.",
    composition: "Azelaic Acid (20% w/w)",
    bestSuitedFor: "सभी प्रकार की त्वचा",
    productForm: "Gel",
    areaOfApplication: "Face",
    faqs: [
        { question: "Who should use Aziderm 20% Gel?", answer: "It’s recommended for individuals with acne-prone skin who want to reduce breakouts, inflammation, and acne-causing bacteria." },
        { question: "What are its benefits?", answer: "The 20% concentration helps target acne-causing bacteria and calm inflammation, supporting clearer, healthier-looking skin with regular use." },
        { question: "Are there any side effects?", answer: "Some users may experience mild irritation or sensitivity. If discomfort persists, consult a healthcare professional." }
    ]
},
"51219367297336": {
    image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/benzac_gel_dermat.png?v=1772600712", // Add valid URL
     images: ["https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Benzac_card.png?v=1772600713"],
    title: "Benzac AC 2.5% Gel",
    quantityLabel: "30 gm",
    price: 123.61,
    benefits: ["एंटी-एक्ने", "रोमछिद्रों को साफ़ करता है"],
    description: "Benzac AC 2.5% Gel मुंहासे पैदा करने वाले बैक्टीरिया को निशाना बनाकर चेहरे, छाती और पीठ के पिंपल्स को कम करने में मदद करता है। यह त्वचा की गहराई तक काम करता है, दाग-धब्बों को घटाता है और भविष्य में होने वाले ब्रेकआउट्स को रोकने में सहायक है, जिससे नियमित उपयोग के साथ त्वचा अधिक साफ़ और स्वस्थ दिखती है।",
    composition: "BENZOYL PEROXIDE-2.5%W/W",
    bestSuitedFor: "मुंहासे-प्रवण त्वचा",
    productForm: "जेल",
    areaOfApplication: "चेहरा",
    faqs: [
        { question: "Benzac AC 2.5% Gel का उपयोग किस लिए किया जाता है?", answer: " यह एक एंटीबैक्टीरियल दवा है, जो बंद रोमछिद्रों और मुंहासे पैदा करने वाले बैक्टीरिया को लक्ष्य बनाकर एक्ने के इलाज में उपयोग होती है।" },
        { question: "यह कैसे काम करता है?", answer: " इसमें बेंज़ॉयल पेरॉक्साइड होता है, जो मुंहासे पैदा करने वाले बैक्टीरिया को खत्म करता है, सूजन को कम करता है और रोमछिद्रों को खोलने में मदद करता है। लगाने पर यह ऑक्सीजन रिलीज करता है, जो Propionibacterium acnes को नष्ट करता है और ब्रेकआउट्स को कम करता है।" },
        { question: "इसके साइड इफेक्ट्स क्या हैं?", answer: "सामान्य साइड इफेक्ट्स में सूखापन, लालिमा, हल्की जलन, खुजली या इरिटेशन शामिल हो सकते हैं। ये आमतौर पर अस्थायी होते हैं, लेकिन यदि लंबे समय तक बने रहें तो डॉक्टर से सलाह लें।" }
    ]
},
"51219360317752": {
    image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/episoft_dermat.png?v=1772600712", // Add valid URL
      images: ["https://cdn.shopify.com/s/files/1/0916/8178/4120/files/episoft_card.png?v=1772600713"],
    title: "Episoft-CL Cleansing Lotion",
    quantityLabel: "125 ml",
    price: 450,
    benefits: ["pH संतुलन", "हाइड्रेटिंग"],
    description: "Episoft-CL Cleansing Lotion एक सौम्य और मॉइस्चराइजिंग क्लींजर है, जो खासतौर पर ड्राई और सेंसिटिव त्वचा के लिए बनाया गया है। इसका pH-बैलेंस्ड, सल्फेट-फ्री, पैराबेन-फ्री और फ्रेगरेंस-फ्री फॉर्मूला त्वचा की प्राकृतिक नमी को बनाए रखते हुए सफाई करता है। इसमें मौजूद हल्के क्लींजिंग एजेंट्स और स्किन कंडीशनर्स गंदगी और अशुद्धियों को हटाकर त्वचा को मुलायम, शांत और ताज़ा महसूस कराते हैं — रोज़ाना इस्तेमाल के लिए उपयुक्त।",
    composition: "Purified Water, Cetearyl Alcohol, 1,3 Butylene glycol, Sodium Lauroyl Sarcosinate",
    bestSuitedFor: "सेंसिटिव त्वचा",
    productForm: "लोशन",
    areaOfApplication: "चेहरा",
    faqs: [ { question: "UV Doux Mineral Sunscreen Gel SPF 50 PA+++ क्या है?", answer: "यह एक मिनरल-बेस्ड सनस्क्रीन जेल है, जो UVA और UVB से ब्रॉड-स्पेक्ट्रम सुरक्षा प्रदान करता है और सभी त्वचा प्रकारों, खासकर सेंसिटिव त्वचा के लिए उपयुक्त है।" },
        { question: "क्या यह व्हाइट कास्ट छोड़ता है?", answer: "नहीं, यह मैट और नॉन-ग्रीसी फिनिश देता है और कोई स्पष्ट व्हाइट कास्ट नहीं छोड़ता।" },
         { question: "इसे कैसे इस्तेमाल करना चाहिए?", answer: "धूप में जाने से 15–20 मिनट पहले लगाएं और हर 3–4 घंटे में दोबारा लगाएं, खासकर तैराकी या पसीना आने के बाद।" }
    ]
},
"51219355107640": {
    image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/venusia_dermat.png?v=1772600712", // Add valid URL
     images: ["https://cdn.shopify.com/s/files/1/0916/8178/4120/files/venusia_card.png?v=1772600712"],
    title: "Venusia Derm Moisturizing Cream",
    quantityLabel: "75 gm",
    price: 365,
    benefits: ["हाइड्रेटिंग", "खुजली से राहत देता है"],
    description: "Venusia Derm Face & Body Moisturizing Cream एक हल्की और नॉन-ग्रीसी क्रीम है, जो ड्राई और इरिटेटेड त्वचा को गहराई से हाइड्रेट करती है। इसमें शीया, एलो, मैंगो और कोको बटर जैसे तत्व शामिल हैं, जो रूखापन कम करते हैं और त्वचा की नमी को लॉक करते हैं। इसका PAMA-फ्री फॉर्मूला त्वचा की बैरियर को मजबूत करने में मदद करता है, जिससे त्वचा मुलायम, स्मूद और आरामदायक महसूस होती है — रोज़ाना उपयोग के लिए सभी त्वचा प्रकारों के लिए उपयुक्त।",
    composition: "Purified water, Shea butter, Aloe butter, Mango butter, Cocoa butter, Zinc oxide",
    bestSuitedFor: "सभी प्रकार की त्वचा",
    productForm: "क्रीम",
    areaOfApplication: "चेहरा और शरीर",
    faqs: [
          { question: "Venusia Derm Face & Body Moisturizing Cream किन त्वचा समस्याओं में मदद करती है?", answer: "यह रूखापन, खुजली और जलन को कम करने में मदद करती है और त्वचा की प्राकृतिक सुरक्षा परत (skin barrier) को मजबूत बनाती है।" },
        { question: "क्या इसे चेहरे और शरीर दोनों पर इस्तेमाल किया जा सकता है?", answer: "हाँ, यह चेहरे और शरीर दोनों के उपयोग के लिए बनाई गई है।" },
          { question: "क्या यह सेंसिटिव त्वचा के लिए उपयुक्त है?", answer: "हाँ, यह हाइपोएलर्जेनिक है, त्वचा को इरिटेट नहीं करती और सेंसिटिव त्वचा के लिए सुरक्षित है।" }
    ]
},
"51219358875960": {
    image: "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/UV_doux_dermat.png?v=1772600712", // Add valid URL
      images: ["https://cdn.shopify.com/s/files/1/0916/8178/4120/files/UVDoux_card.png?v=1772600712"],
    title: "UV Doux Mineral Sunscreen Gel",
    quantityLabel: "50 gm",
    price: 949,
    benefits: ["सूरज से सुरक्षा", "UV डैमेज की मरम्मत में मदद"],
    description: "UV Doux Mineral Sunscreen Gel SPF 50 PA+++ एक 100% फिजिकल सनस्क्रीन है, जिसमें जिंक ऑक्साइड और आयरन ऑक्साइड शामिल हैं, जो ब्रॉड-स्पेक्ट्रम सुरक्षा प्रदान करते हैं। इसका टिंटेड, मैट और ऑयल-फ्री फॉर्मूला सभी त्वचा प्रकारों के लिए उपयुक्त है और यह बिना व्हाइट कास्ट के फिनिश देता है—रोज़ाना उपयोग के लिए आदर्श।",
    composition: "Dimethicone, Dimethicone Crosspolymer, Zinc Oxide, Triethoxycaprylylsilane, C15-19 Alkane, Coco Caprylate/Caprate, Cetyl Dimethicone, C15-23 Alkanes, Hydrogenated Soy Polyglycerides, Isododecane, Dimethicone/Bis-Isobutyl PPG-20 Crosspolymer, Caprylyl Methicone, PEG-12 Dimethicone/PPG-20 Crosspolymer, Polyhydroxystearic Acid,Silica,CI 77492, Isopropyl Titanium Triisostearate,Bis-PEG-15 Dimethicone/IPDI Copolymer, PEG-2 Soyamine, Caprylic Capric Triglyceride, Physalis Angulata Extract",
    bestSuitedFor: "सभी प्रकार की त्वचा",
    productForm: "जेल",
    areaOfApplication: "चेहरा",
    faqs: [
        { question: "Does it leave a white cast?", answer: "No, it offers a matte, non-greasy finish without a noticeable white cast." }
    ]
}
    };

    // --- SUPPORTIVE CARE CONFIGURATION ---
    const supportiveCareProductIds = [
        "51588893835576", // Glameron Face Mask (DEFAULT VISIBLE)
        "51598963638584", // Cosderma Clear Face Sheet Mask
        "51599001846072", //Acnepad Salicylic Acid & Glycolic Acid Wipes
        "51599014691128",//Rega-BPO Acne Spot Corrector Gel
        "51599016362296", // Brilante Intense Brightening Serum (recommedate)
       
    ];

    // =========================================================
    // 2. DIAGNOSIS & USER DISPLAY
    // =========================================================
    const firstname = localStorage.getItem('userFirstname');
    if (firstname) {
        const firstNameOnly = firstname.split(' ')[0];
        document.querySelectorAll('[id="user-first-name"]').forEach(el => el.textContent = firstNameOnly);
    }

    const diagnosis = localStorage.getItem('skinDiagnosis') || 'Acne prone skin with mild inflammation';
    document.querySelectorAll('[id="skin-diagnosis"]').forEach(el => el.textContent = diagnosis);

    // Skin Type
      const skinTypeDataMap = {
        'Dry': { image: 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/dry_1.png?v=1761383070' },
        'Oily': { image: 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/oily_1.png?v=1761383070' },
        'Combined': { image: 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/combination_1.png?v=1761383070' },
        'Normal': { image: 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/normal_1.png?v=1761383070' },
        'Sensitive': { image: 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/sensitive_1.png?v=1761383070' }
    };
    // const skinTypeContainer = document.getElementById('skin-type-display-container');
    // const selectedSkinTypes = JSON.parse(localStorage.getItem('userSkinType') || '["Normal"]');

    // if (skinTypeContainer) {
    //     skinTypeContainer.innerHTML = '';
    //     if (selectedSkinTypes.length > 0) {
    //         const imagesContainer = document.createElement('div');
    //         Object.assign(imagesContainer.style, { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px' });
    //         selectedSkinTypes.forEach((type, index) => {
    //             const data = skinTypeDataMap[type];
    //             if (data) {
    //                 const img = document.createElement('img');
    //                 img.src = data.image; img.alt = `${type} Skin Icon`;
    //                 Object.assign(img.style, { width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' });
    //                 if (index > 0) img.style.marginLeft = '-10px';
    //                 imagesContainer.appendChild(img);
    //             }
    //         });
    //         const textElement = document.createElement('span');
    //         textElement.style.fontSize = '1rem';
    //         textElement.innerHTML = ` Skin type: <strong> ${selectedSkinTypes.join(', ')} </strong> `;
    //         skinTypeContainer.append(imagesContainer, textElement);
    //     } else {
    //         skinTypeContainer.innerHTML = '<span style="font-size:1rem">Skin type: Not specified</span>';
    //     }
    // }
    // =========================================================
// 2. DIAGNOSIS & USER DISPLAY (PATH-SPECIFIC SKIN TYPE)
// =========================================================

const skinTypeContainer = document.getElementById('skin-type-display-container');
const selectedSkinTypes = JSON.parse(localStorage.getItem('userSkinType') || '["Normal"]');
const isRecommendationPage = window.location.pathname.includes('/pages/recommendation-page');
const isWomenRecommedationPage = window.location.pathname.includes('/pages/hindi-women-recommendation-page');
const isWomenPregencyMotherhoodRecommedationPage=  window.location.pathname.includes('/pages/hindi-women-pregnancy-motherhood-recommedation-page');
const ishindiRecommedationPage=  window.location.pathname.includes('/pages/recommedation-page-hindi');

// Define the Data Maps for different pages
const standardIcons = {
    'Dry': 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/dry_1.png?v=1761383070',
    'Oily': 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/oily_1.png?v=1761383070',
    'Combined': 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/combination_1.png?v=1761383070',
    'Normal': 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/normal_1.png?v=1761383070',
    'Sensitive': 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/sensitive_1.png?v=1761383070'
};

const recommendationIcons = {
    'Dry': 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/dry_2.png?v=1770287121',
    'Oily': 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/oily_2.png?v=1770287121',
    'Combined': 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/combination_2.png?v=1770287121',
    'Normal': 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/normal_2.png?v=1770287121',
    'Sensitive': 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Sensitive_2.png?v=1770287122'
};

if (skinTypeContainer) {
    skinTypeContainer.innerHTML = '';

    if (isRecommendationPage ||isWomenRecommedationPage || isWomenPregencyMotherhoodRecommedationPage ||ishindiRecommedationPage) {
        // --- NEW STYLE FOR RECOMMENDATION PAGE ---
        Object.assign(skinTypeContainer.style, {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '20px 0',
            borderTop: '1px solid #B5BBC0',
            borderBottom: '1px solid #B5BBC0',
            width: '100%'
        });

        const textElement = document.createElement('span');
        Object.assign(textElement.style, {
            color: '#2F2F2F',
            fontFamily: 'Nacelle, sans-serif',
            fontSize: '1.5rem',
            fontWeight: '300',
            lineHeight: 'normal'
        });
        textElement.innerHTML = `स्किन टाइप: <strong style="font-weight: 600;">${selectedSkinTypes.join(', ')}</strong>`;

        const iconsWrapper = document.createElement('div');
        iconsWrapper.style.display = 'flex';
        iconsWrapper.style.gap = '10px';

        selectedSkinTypes.forEach(type => {
            const img = document.createElement('img');
            img.src = recommendationIcons[type] || recommendationIcons['Normal'];
            img.style.width = '50px';
            img.style.height = '50px';
            iconsWrapper.appendChild(img);
        });

        skinTypeContainer.appendChild(textElement);
        skinTypeContainer.appendChild(iconsWrapper);

    } else {
        // --- OLD STYLE FOR OTHER PAGES (Women, Student, etc.) ---
        Object.assign(skinTypeContainer.style, {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '8px',
            paddingBottom: '12px',
            borderBottom: '1px solid #B5BBC0'
        });

        const imagesContainer = document.createElement('div');
        Object.assign(imagesContainer.style, { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px' });
        
        selectedSkinTypes.forEach((type, index) => {
            const img = document.createElement('img');
            img.src = standardIcons[type] || standardIcons['Normal'];
            Object.assign(img.style, { width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' });
            if (index > 0) img.style.marginLeft = '-10px';
            imagesContainer.appendChild(img);
        });

        const textElement = document.createElement('span');
        textElement.style.fontSize = '1rem';
        textElement.innerHTML = `Skin type: <strong>${selectedSkinTypes.join(', ')}</strong>`;
        
        skinTypeContainer.append(imagesContainer, textElement);
    }
}
// =========================================================
// 2. DIAGNOSIS & USER DISPLAY (AYURVEDA DYNAMIC IMAGES)
// =========================================================

// 1. PATH DETECTION
const path = window.location.pathname;
const isRecommendationPath = path.includes('/pages/recommendation-page');
const isStudentPath = path.includes('/pages/student-recommedation-page');
const isWomenPath = path.includes('/pages/women-recommedation-page');
const isWomenPregencyMotherhoodRecommedationPath = path.includes('/pages/hindi-women-pregnancy-motherhood-recommedation-page');
const ishindiRecommedationpath =path.includes('/pages/recommedation-page-hindi');
// 2. DEFINE BASE DATA (Descriptions remain the same)
let ayurvedaDataMap = {
    'Stress': { description: 'तनाव कोर्टिसोल को बढ़ाता है, जिससे तेल (ऑयल) का उत्पादन बढ़ता है, रोमछिद्र (पोर्स) बंद हो जाते हैं और मुंहासे (एक्ने) बढ़ जाते हैं।' },
    'Hormonal': { description: 'हार्मोनल असंतुलन त्वचा में तेल उत्पादन बढ़ाता है, जिससे रोमछिद्र बंद होते हैं और मुंहासे निकलते हैं।' },
    'Gut': { description: 'खराब आंत (गट) स्वास्थ्य सूजन और हार्मोन असंतुलन को बढ़ाकर मुंहासों (एक्ने) को ट्रिगर कर सकता है।' },
    'Sleep': { description: 'नींद की कमी तनाव हार्मोन को बढ़ाती है और त्वचा की खुद को ठीक करने की क्षमता को कम करती है, जिससे मुंहासे हो सकते हैं।' },
    'Lifestyle': { description: 'No gut, sleep, stress, or hormonal imbalance detected.' }
};

// 3. ASSIGN IMAGES BASED ON PATH
if (isRecommendationPath) {
    ayurvedaDataMap['Stress'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/stress_icon_afe9d64f-67e4-4337-bdbe-50643afdcb53.png?v=1770288136';
    ayurvedaDataMap['Hormonal'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Hormonal_issues_3.png?v=1770288136';
    ayurvedaDataMap['Gut'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/gut_health_5.png?v=1770288136';
    ayurvedaDataMap['Sleep'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Sleep_5.png?v=1770288136';
    ayurvedaDataMap['Lifestyle'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/lifestyle_skin_factors_only_1.png?v=1770288136';
} 
else if (isStudentPath) {
    ayurvedaDataMap['Stress'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Stress_4.png?v=1769668857';
    ayurvedaDataMap['Gut'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/gut_health_4.png?v=1769668857';
    ayurvedaDataMap['Sleep'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Sleep_4.png?v=1769668857';
    ayurvedaDataMap['Hormonal'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Hormonal_issues_2.png?v=1769668857';
}
else if (isWomenPath) {
    ayurvedaDataMap['Stress'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Stress_5.png?v=1770786460';
    ayurvedaDataMap['Gut'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/gut_health_6.png?v=1770786445';
    ayurvedaDataMap['Sleep'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/sleep_6.png?v=1770786446';
    ayurvedaDataMap['Hormonal'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Hormonal_issues_4.png?v=1770786446';
    ayurvedaDataMap['Lifestyle'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/lifestyle_skin_factors_only_2.png?v=1770892714';
}
else if (ishindiRecommedationpath) {
    ayurvedaDataMap['Stress'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/stress_6.png?v=1775306763';
    ayurvedaDataMap['Gut'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/gut_health_9.png?v=1775306762';
    ayurvedaDataMap['Sleep'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/sleep_7.png?v=1775306763';
    ayurvedaDataMap['Hormonal'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Hormonal_issues_6.png?v=1775306763';
    ayurvedaDataMap['Lifestyle'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/lifestyle_skin_factors_only_3.png?v=1775307853';
}
else if (isWomenPregencyMotherhoodRecommedationPath) {
    ayurvedaDataMap['Stress'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/stress_6.png?v=1775306763';
    ayurvedaDataMap['Gut'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/gut_health_9.png?v=1775306762';
    ayurvedaDataMap['Sleep'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/sleep_7.png?v=1775306763';
    ayurvedaDataMap['Hormonal'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Hormonal_issues_6.png?v=1775306763';
    ayurvedaDataMap['Lifestyle'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/lifestyle_skin_factors_only_3.png?v=1775307853';
}
else {
    // DEFAULT IMAGES
    ayurvedaDataMap['Stress'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Stress_3.png?v=1769668392';
    ayurvedaDataMap['Gut'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/gut_health_3.png?v=1769668404';
    ayurvedaDataMap['Sleep'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Sleep_3.png?v=1769668395';
    ayurvedaDataMap['Hormonal'].image = 'https://cdn.shopify.com/s/files/1/0916/8178/4120/files/Hormonal_issues_1.png?v=1769668400';
}

// 3. SELECTION LOGIC
const rootDiagnosisString = localStorage.getItem('ayurvedaDiagnosis') || '';
const ayurvedaTypes = [];
if (rootDiagnosisString.includes('Gut')) ayurvedaTypes.push('Gut');
if (rootDiagnosisString.includes('Sleep')) ayurvedaTypes.push('Sleep');
if (rootDiagnosisString.includes('Stress')) ayurvedaTypes.push('Stress');
if (rootDiagnosisString.includes('Hormonal')) ayurvedaTypes.push('Hormonal');

// FALLBACK: If nothing selected and we are on Recommendation Page, show Lifestyle
if (ayurvedaTypes.length === 0 && (isRecommendationPath || isWomenPath || isWomenPregencyMotherhoodRecommedationPath)
) {
    ayurvedaTypes.push('Lifestyle');
}

// 4. RENDERING
const ayurvedaContainer = document.getElementById('ayurveda-diagnosis-container');
if (ayurvedaContainer) {
    const activeClass = isStudentPath ? 'active-student' : 'active-standard';
    ayurvedaContainer.innerHTML = '';

    if (ayurvedaTypes.length > 0) {
        const imagesRow = document.createElement('div'); imagesRow.className = 'ayurveda-images-row';
        const descriptionsRow = document.createElement('div'); descriptionsRow.className = 'ayurveda-descriptions-row';
        let firstDescElement = null;

        ayurvedaTypes.forEach((type, index) => {
            const data = ayurvedaDataMap[type];
            if (data) {
                const imgWrapper = document.createElement('div'); imgWrapper.className = 'ayurveda-image-wrapper';
                const img = document.createElement('img'); 
                img.src = data.image; 
                img.className = 'ayurveda-image';
                if (index === 0) img.classList.add(activeClass);

                img.dataset.targetDesc = `desc-${type}`;
                imgWrapper.appendChild(img); 
                imagesRow.appendChild(imgWrapper);

                const desc = document.createElement('p'); 
                desc.textContent = data.description;
                desc.className = 'ayurveda-description'; 
                desc.id = `desc-${type}`; 
                desc.style.display = (index === 0) ? 'block' : 'none';
                descriptionsRow.appendChild(desc);
            }
        });

        ayurvedaContainer.append(imagesRow, descriptionsRow);

        // Click Handler for Interactivity
        ayurvedaContainer.addEventListener('click', (e) => {
            const clickedImg = e.target.closest('.ayurveda-image');
            if (clickedImg) {
                ayurvedaContainer.querySelectorAll('.ayurveda-image').forEach(i => i.classList.remove(activeClass));
                clickedImg.classList.add(activeClass);
                ayurvedaContainer.querySelectorAll('.ayurveda-description').forEach(d => d.style.display = 'none');
                const target = document.getElementById(clickedImg.dataset.targetDesc);
                if (target) target.style.display = 'block';
            }
        });
    }
}
// =========================================================
// DYNAMIC INDIVIDUAL INSIGHT CARDS WITH BACKGROUND IMAGES
// =========================================================
const insightViewport = document.getElementById('dynamic-insight-viewport');
const dotsContainer = document.getElementById('insight-dots-container');

if (insightViewport && dotsContainer) {
    const rootDiagnosisString = localStorage.getItem('ayurvedaDiagnosis') || '';
    const hasGut = rootDiagnosisString.includes('Gut');
    const hasStress = rootDiagnosisString.includes('Stress') || rootDiagnosisString.includes('Sleep');

    // Updated Template: Added bgImage parameter
    const createInsightCard = (percentage, mainText, bgImage = null) => {
        // Create style string if bgImage exists
        const bgStyle = bgImage ? `style="background-image: url('${bgImage}'); background-size: cover; background-position: center;"` : "";
        
        return `
            <div class="individual-insight-card data-section" ${bgStyle}>
                <div class="stat-block">
                    <p class="main-text">
                        <strong>${percentage}</strong><br>
                        ${mainText}
                    </p>
                </div>
                <div class="plan-note">
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
  <circle cx="9" cy="9" r="8.5" stroke="white" fill="none" />
  <path d="M5 6.33333L8.89097 11L19 4" stroke="white" stroke-linecap="round" fill="none"/>
</svg>
                    </div>
                    <p class="note-text">
                        Your treatment plan is designed with these factors in mind and adjusted as needed.
                    </p>
                </div>
                <div class="footer">
                    <p class="footer-text">Based on insights from women who’ve reached out to Clinderma</p>
                </div>
            </div>
        `;
    };

    const gutMsg = "of women show signs of gut-related triggers affecting their skin.";
    const stressMsg = "of women struggle with stress or sleep issues that worsen breakouts.";
    const defaultMsg = "of women experience moderate to severe acne along with pigmentation concerns.";
    const gutBg = "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/50.png?v=1770796178";
    const stressBg = "https://cdn.shopify.com/s/files/1/0916/8178/4120/files/30.png?v=1770895123";
    let cardHtml = "";
    let dotCount = 0;

    if (hasGut && hasStress) {
        insightViewport.classList.add('is-scrollable');
        // Apply background to the 50% card only
        cardHtml = createInsightCard("50%", gutMsg, gutBg) + createInsightCard("30%", stressMsg,stressBg);
        dotCount = 2;
    } else {
        insightViewport.classList.remove('is-scrollable');
        dotCount = 0;
        if (hasGut) cardHtml = createInsightCard("50%", gutMsg, gutBg);
        else if (hasStress) cardHtml = createInsightCard("30%", stressMsg,stressBg);
        // else cardHtml = createInsightCard("70%", defaultMsg);
    }

    insightViewport.innerHTML = cardHtml;

    // --- DOT GENERATION & SCROLL LOGIC ---
    dotsContainer.innerHTML = "";
    if (dotCount > 1) {
        for (let i = 0; i < dotCount; i++) {
            const dot = document.createElement('span');
            dot.className = `insight-dot ${i === 0 ? 'active' : ''}`;
            dotsContainer.appendChild(dot);
        }

        insightViewport.addEventListener('scroll', () => {
            const scrollLeft = insightViewport.scrollLeft;
            const cardWidth = insightViewport.querySelector('.individual-insight-card').offsetWidth;
            const index = Math.round(scrollLeft / cardWidth);
            
            const dots = dotsContainer.querySelectorAll('.insight-dot');
            dots.forEach((dot, i) => {
                dot.classList.toggle('active', i === index);
            });
        });
    }
}
    // =========================================================
    // 3. PRODUCT RENDERING HELPERS
    // =========================================================
    const mobileProductGrid = document.getElementById('product-list-mobile');
    const desktopProductGrid = document.getElementById('product-list-desktop');
    const skinProductIds = JSON.parse(localStorage.getItem('skinProductIds') || '[]');
     const createProductCardHtml = (id, productData, isMobileView) => {
    const isSupportiveCare = supportiveCareProductIds.includes(id);
  const isRecommendationPage = window.location.pathname.includes('/pages/recommendation-page');
    // 1. DELETE BUTTON LOGIC
    const removeBtn = isMobileView
        ? `<div class="remove-product-button"><img src="https://cdn.shopify.com/s/files/1/0916/8178/4120/files/delete.png?v=1755002698" width="16"><span>DELETE</span></div>`
        : `<div class="remove-product-button"><img src="https://cdn.shopify.com/s/files/1/0916/8178/4120/files/delete.png?v=1755002698" width="16"></div>`;
// 2. DAY/NIGHT ICONS (New Recommendation Page Logic)
    let timingHtml = '';
    if (isRecommendationPage) {
        const dayIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><mask id="mask0_day" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20"><rect width="20" height="20" fill="#D9D9D9"/></mask><g mask="url(#mask0_day)"><path d="M9.99938 4.34299C9.82215 4.34299 9.67375 4.28313 9.55417 4.16341C9.43445 4.04354 9.37458 3.89507 9.37458 3.71799V1.89111C9.37458 1.71403 9.43451 1.56563 9.55438 1.44591C9.67424 1.32604 9.82271 1.26611 9.99979 1.26611C10.177 1.26611 10.3254 1.32604 10.445 1.44591C10.5647 1.56563 10.6246 1.71403 10.6246 1.89111V3.71799C10.6246 3.89507 10.5647 4.04354 10.4448 4.16341C10.3249 4.28313 10.1765 4.34299 9.99938 4.34299ZM13.9965 6.0032C13.881 5.88792 13.8247 5.74507 13.8273 5.57466C13.8299 5.40424 13.889 5.25438 14.0044 5.12507L15.2752 3.82549C15.4006 3.69618 15.5495 3.63153 15.7219 3.63153C15.8942 3.63153 16.0456 3.69674 16.176 3.82715C16.2956 3.94674 16.3554 4.0925 16.3554 4.26445C16.3554 4.43653 16.295 4.58292 16.1742 4.70361L14.8746 6.0032C14.7539 6.12403 14.6075 6.18445 14.4354 6.18445C14.2635 6.18445 14.1172 6.12403 13.9965 6.0032ZM16.2817 10.6251C16.1046 10.6251 15.9561 10.5651 15.8363 10.4453C15.7165 10.3254 15.6567 10.1769 15.6567 9.99986C15.6567 9.82264 15.7165 9.67424 15.8363 9.55466C15.9561 9.43493 16.1046 9.37507 16.2817 9.37507H18.1085C18.2856 9.37507 18.434 9.435 18.5537 9.55486C18.6736 9.67472 18.7335 9.8232 18.7335 10.0003C18.7335 10.1775 18.6736 10.3259 18.5537 10.4455C18.434 10.5652 18.2856 10.6251 18.1085 10.6251H16.2817ZM9.99938 18.734C9.82215 18.734 9.67375 18.6741 9.55417 18.5542C9.43445 18.4345 9.37458 18.2861 9.37458 18.109V16.2901C9.37458 16.113 9.43451 15.9646 9.55438 15.8449C9.67424 15.725 9.82271 15.6651 9.99979 15.6651C10.177 15.6651 10.3254 15.725 10.445 15.8449C10.5647 15.9646 10.6246 16.113 10.6246 16.2901V18.109C10.6246 18.2861 10.5647 18.4345 10.4448 18.5542C10.3249 18.6741 10.1765 18.734 9.99938 18.734ZM5.13271 6.0032L3.825 4.72445C3.69569 4.59959 3.63104 4.44868 3.63104 4.27174C3.63104 4.09493 3.69569 3.94618 3.825 3.82549C3.94569 3.71007 4.09382 3.65236 4.26938 3.65236C4.44493 3.65236 4.58951 3.71007 4.70313 3.82549L6.01083 5.1332C6.12625 5.24681 6.18396 5.39139 6.18396 5.56695C6.18396 5.7425 6.12681 5.88792 6.0125 6.0032C5.88778 6.11861 5.74229 6.17632 5.57604 6.17632C5.40965 6.17632 5.26187 6.11861 5.13271 6.0032ZM15.2833 16.1747L14.0044 14.8751C13.889 14.7458 13.8299 14.5959 13.8273 14.4255C13.8247 14.2551 13.8805 14.1122 13.9948 13.9969C14.1091 13.8815 14.252 13.8238 14.4235 13.8238C14.5949 13.8238 14.7453 13.8842 14.8746 14.0049L16.1742 15.2838C16.2982 15.3991 16.3581 15.5441 16.3538 15.7188C16.3494 15.8935 16.2888 16.0455 16.1719 16.1747C16.0442 16.304 15.8926 16.3686 15.7171 16.3686C15.5414 16.3686 15.3968 16.304 15.2833 16.1747ZM1.89062 10.6251C1.71354 10.6251 1.56514 10.5651 1.44542 10.4453C1.32556 10.3254 1.26562 10.1769 1.26562 9.99986C1.26562 9.82264 1.32556 9.67424 1.44542 9.55466C1.56514 9.43493 1.71354 9.37507 1.89062 9.37507H3.7175C3.89458 9.37507 4.04306 9.435 4.16292 9.55486C4.28264 9.67472 4.3425 9.8232 4.3425 10.0003C4.3425 10.1775 4.28264 10.3259 4.16292 10.4455C4.04306 10.5652 3.89458 10.6251 3.7175 10.6251H1.89062ZM3.83292 16.1747C3.7175 16.054 3.65847 15.9063 3.65583 15.7315C3.65319 15.5569 3.70958 15.4119 3.825 15.2965L5.11667 14.0049C5.23736 13.8842 5.3816 13.8238 5.54938 13.8238C5.71701 13.8238 5.86549 13.8836 5.99479 14.0032C6.1241 14.1336 6.18875 14.284 6.18875 14.4544C6.18875 14.6249 6.1241 14.7747 5.99479 14.9038L4.72396 16.1747C4.59465 16.304 4.44222 16.3686 4.26667 16.3686C4.09111 16.3686 3.94653 16.304 3.83292 16.1747ZM10.0015 14.5834C8.72882 14.5834 7.64646 14.138 6.75438 13.2472C5.86229 12.3563 5.41625 11.2746 5.41625 10.0019C5.41625 8.72931 5.86167 7.64695 6.7525 6.75486C7.64333 5.86278 8.72507 5.41674 9.99771 5.41674C11.2703 5.41674 12.3527 5.86216 13.2448 6.75299C14.1369 7.64382 14.5829 8.72556 14.5829 9.9982C14.5829 11.2708 14.1375 12.3532 13.2467 13.2453C12.3558 14.1374 11.2741 14.5834 10.0015 14.5834ZM9.99958 13.3334C10.9163 13.3334 11.701 13.007 12.3538 12.3542C13.0065 11.7015 13.3329 10.9167 13.3329 10.0001C13.3329 9.0834 13.0065 8.29868 12.3538 7.64591C11.701 6.99313 10.9163 6.66674 9.99958 6.66674C9.08292 6.66674 8.29819 6.99313 7.64542 7.64591C6.99264 8.29868 6.66625 9.0834 6.66625 10.0001C6.66625 10.9167 6.99264 11.7015 7.64542 12.3542C8.29819 13.007 9.08292 13.3334 9.99958 13.3334Z" fill="#567C8D"/></g></svg>`;
        
        const nightIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><mask id="mask0_night" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20"><rect width="20" height="20" fill="#D9D9D9"/></mask><g mask="url(#mask0_night)"><path d="M10.0245 17.0839C8.05023 17.0839 6.37613 16.397 5.00224 15.0231C3.62835 13.6491 2.94141 11.9749 2.94141 10.0006C2.94141 8.35643 3.45016 6.8949 4.46766 5.61601C5.4853 4.33712 6.84078 3.51288 8.53411 3.1433C8.70939 3.09941 8.86377 3.10365 8.99724 3.15601C9.13085 3.20837 9.23932 3.28636 9.32266 3.38997C9.40599 3.49372 9.45516 3.61955 9.47016 3.76747C9.48502 3.91538 9.45029 4.06309 9.36599 4.21059C9.19391 4.52365 9.0662 4.84886 8.98286 5.18622C8.89953 5.52358 8.85786 5.87837 8.85786 6.25059C8.85786 7.61629 9.33592 8.77719 10.292 9.7333C11.248 10.6893 12.4088 11.1673 13.7745 11.1673C14.1838 11.1673 14.5749 11.1155 14.9477 11.0118C15.3206 10.9082 15.647 10.788 15.9268 10.6512C16.0636 10.5915 16.1972 10.5704 16.3274 10.5879C16.4579 10.6055 16.5691 10.6491 16.6612 10.7185C16.7636 10.788 16.8395 10.8828 16.8891 11.0031C16.9388 11.1232 16.9445 11.2645 16.906 11.4268C16.61 13.0657 15.8127 14.4183 14.5141 15.4846C13.2155 16.5508 11.719 17.0839 10.0245 17.0839ZM10.0245 15.8339C11.2468 15.8339 12.344 15.4971 13.3162 14.8235C14.2884 14.1499 14.9968 13.2714 15.4412 12.1881C15.1634 12.2575 14.8856 12.3131 14.6079 12.3548C14.3301 12.3964 14.0523 12.4173 13.7745 12.4173C12.0662 12.4173 10.6113 11.8166 9.40995 10.6152C8.20856 9.41379 7.60786 7.95893 7.60786 6.25059C7.60786 5.97281 7.6287 5.69504 7.67036 5.41726C7.71203 5.13948 7.76759 4.8617 7.83703 4.58393C6.7537 5.02837 5.87523 5.7367 5.20161 6.70893C4.528 7.68115 4.1912 8.77837 4.1912 10.0006C4.1912 11.6117 4.76064 12.9867 5.89953 14.1256C7.03842 15.2645 8.41342 15.8339 10.0245 15.8339Z" fill="#567C8D"/></g></svg>`;

        const timingStyle = `color: #567C8D; font-family: Nacelle; font-size: 12px; font-weight: 300; line-height: 111.188%; text-transform: uppercase; display: flex; align-items: center; gap: 4px; margin-bottom: 8px;`;

        timingHtml = `
            <div class="product-timing-wrapper" style="display: flex; gap: 16px;">
                <div style="${timingStyle}">${dayIcon} AM</div>
                <div style="${timingStyle}">${nightIcon} PM</div>
            </div>
        `;
    }
    // 3. PRICE & QUANTITY LOGIC
    const priceSection = isSupportiveCare
        ? `<div class="product-qty-wrapper" data-qty="1" data-unit-price="${productData.price}">
            <button class="product-qty-btn minus" aria-label="Decrease"><svg xmlns="http://www.w3.org/2000/svg" width="8" height="2"><path d="M0.5 1H7.5" stroke="#2F444E" stroke-width="1.2"/></svg></button>
            <span class="product-qty-value">1</span>
            <button class="product-qty-btn plus" aria-label="Increase"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path d="M10 5V15M5 10H15" stroke="#2F444E" stroke-width="1.5"/></svg></button>
           </div><p class="product-price">₹${productData.price}</p>`
        : `<p class="product-price">₹${productData.price}</p>`;

  
// 3. BENEFITS LOGIC (CONDITIONAL STYLING)
    
    let benefitsHtml = '';

if (productData.benefits && productData.benefits.length > 0) {
    const path = window.location.pathname;
    const isWomenPage = path.includes('/pages/hindi-women-recommendation-page');
    // New Pregnancy Page Check
    const isPregnancyPage = path.includes('/pages/hindi-women-pregnancy-motherhood-recommedation-page');

    // --- 1. DEFINE STYLES BASED ON PAGE ---
    let config = {
        bgColor: '#E7F3F8',
        textColor: '#2F444E',
        circleColor: '#567C8D',
        checkStroke: '#EEF2F4',
        fontWeight: '300'
    };

    if (isPregnancyPage) {
        config = {
            bgColor: '#FCF8F4',
            textColor: '#7B6651',
            circleColor: '#7B6651',
            checkStroke: '#FCF8F4',
            fontWeight: '300'
        };
    } else if (isWomenPage) {
        config = {
            bgColor: '#FEEEF4',
            textColor: '#882F4F',
            circleColor: '#882F4F',
            checkStroke: '#FEEEF4',
            fontWeight: '300'
        };
    } else if (isSupportiveCare) {
        config = {
            bgColor: '#EDF7EE',
            textColor: '#4CAF50',
            circleColor: '#4CAF50',
            checkStroke: 'white',
            fontWeight: '300'
        };
    }

    // --- 2. DEFINE LAYOUT WRAPPER ---
    // Keep your grid for non-supportive and flex for supportive
    if (isSupportiveCare && !isPregnancyPage) {
        benefitsHtml = `<div style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 6px; margin-top: 8px;">`;
    } else {
        benefitsHtml = `<div class="product-benefits-row" style="display: flex; grid-template-columns: 1fr 1fr; gap: 8px; margin-top: 10px; border-bottom:1px solid #B5BBC0; padding-bottom:2vw; width:100%;flex-wrap:wrap;">`;
    }

    // --- 3. GENERATE ITEMS ---
    productData.benefits.forEach(benefit => {
        benefitsHtml += `
        <div class="benefit-container" style="display: inline-flex; padding: 4px 8px; align-items: center; gap: 8px; border-radius: 6px; background: ${config.bgColor};">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <circle cx="6" cy="6" r="6" fill="${config.circleColor}"/>
                <path d="M3 5.82872L4.63947 7.32353L8.64706 4.5" stroke="${config.checkStroke}" stroke-linecap="round" fill="transparent"/>
            </svg>
            <span style="color: ${config.textColor}; font-family: Nacelle, sans-serif; font-size: 10px; font-weight: ${config.fontWeight}; line-height: normal; white-space: nowrap;">
                ${benefit}
            </span>
        </div>`;
    });

    benefitsHtml += `</div>`;
}
    // 4. MORE DETAILS BUTTON (New Addition)
    // Only showing this for Non-Supportive products to match the 'card' look, 
    // or remove the check (!isSupportiveCare) to show on all.
    let moreDetailsBtn = '';
   
        moreDetailsBtn = `
        <div class="more-details-btn" style="
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 4px;
            
            padding-top: 12px;
            
            cursor: pointer;
            width: 100%;
        ">
            <span style="
                color: var(--Alias-neutral-neutral-500, #5E6B77);
                font-family: Nacelle, sans-serif;
                font-size: 12px;
                font-style: normal;
                font-weight: 300;
                line-height: 111.188%;
            ">View details</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
              <path d="M0.5 0.5L5.75 5.75L0.5 11" stroke="#7E8992" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
            </svg>
        </div>`;
     

    // 5. RETURN HTML
    return `
        <div class="product-card" data-variant-id="${id}" data-price="${productData.price}" data-qty="1">
          <div class="product-image"><img src="${productData.image}" alt="${productData.title}"></div>
          <div class="product-details">
            <div class="product-header-row"><h3>${productData.title}</h3>${!isMobileView ? removeBtn : ''}</div>
            <p class="product-description">${productData.description}</p>
            ${timingHtml}
            ${priceSection} 
            ${benefitsHtml}
            ${moreDetailsBtn}

          </div>
          ${isMobileView ? removeBtn : ''}
        </div>`;
};
 const createSupportiveCardHtml = (id, product) => {
        // USE SUPPORTIVE IMAGE IF AVAILABLE, ELSE DEFAULT
        const imgSrc = product.supportiveImage || product.image;

        // --- BENEFITS LOGIC ---
        let benefitsHtml = '';
        if (product.benefits && product.benefits.length > 0) {
            // Container: Ensure items flow in a row (side-by-side)
            benefitsHtml = `<div style="
                display: flex; 
                flex-direction: row; 
                flex-wrap: wrap; 
                gap: 6px; 
                margin-top: 8px;
                 
                padding-top:3vw;
            ">`;
            
            product.benefits.forEach(benefit => {
                benefitsHtml += `
                <div style="
                    display: flex;
                    width: auto; /* KEY CHANGE: Allows items to sit next to each other */
                    padding: 4px 8px;
                    justify-content: center;
                    align-items: center;
                    gap: 6px;
                    border-radius: 6px;
                    background: var(--Alias-success-success-50, #EDF7EE);
                ">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="transparent">
                      <circle cx="6" cy="6" r="6" fill="#4CAF50"  fill="transparent"/>
                      <path d="M3 5.82872L4.63947 7.32353L8.64706 4.5" stroke="white" stroke-linecap="round" fill="transparent"/>
                    </svg>
                    
                    <span style="
                        color: var(--Alias-success-success-500, #4CAF50);
                        font-family: Nacelle, sans-serif;
                        font-size: 0.75rem;
                        font-weight: 300;
                        line-height: normal;
                        white-space: nowrap;
                    ">${benefit}</span>
                </div>`;
            });
            
            benefitsHtml += `</div>`;
        }
          
        return `
        <div class="supportive-care-card" data-product-id="${id}" data-product-title="${product.title}" data-product-price="${product.price}">
          <div class="supportive-card-left">
            <img src="${imgSrc}" alt="${product.title}" class="supportive-card-image" />
          </div>

          <div class="supportive-card-middle">
            <p class="supportive-card-title">${product.title}</p>
 
           <p class="supportive-card-description" style="color: var(--Alias-neutral-neutral-500, #5E6B77);
                font-family: Nacelle, sans-serif;
                font-size: 12px;
                font-weight: 300;
                line-height: 1.4;
                margin: 4px 0;
                overflow: hidden;
 
                /* Line Clamping Logic */
                display: -webkit-box;
                -webkit-line-clamp: 2; 
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: normal;
                width:180px;">
            ${product.description}
              
        </p>
                    <p class="supportive-card-price">₹${product.price}</p>
                     ${benefitsHtml}
            </div>

          <button class="supportive-card-add-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="transparent">
              <path d="M8.27045 16.2856V9.03252H0.381037C0.170632 9.03252 5.7726e-05 8.86188 0 8.65148C1.84929e-08 8.44104 0.170596 8.27045 0.381037 8.27045H8.27045V0.381037C8.27045 0.170596 8.44104 0 8.65148 0C8.86188 5.73338e-05 9.03252 0.170632 9.03252 0.381037V8.27045H16.2856C16.496 8.27049 16.6667 8.44107 16.6667 8.65148C16.6666 8.86185 16.496 9.03247 16.2856 9.03252H9.03252V16.2856C9.03247 16.496 8.86185 16.6666 8.65148 16.6667C8.44107 16.6667 8.27049 16.496 8.27045 16.2856Z" fill="#4CAF50"/>
            </svg>
          </button>
        </div>`;
    };
     
    // =========================================================
    // 4. RENDERING LOGIC (UPDATED)
    // =========================================================
    
     function refreshSupportiveSection() {
        const container = document.querySelector('.supportive-care-scroll');
        const sectionWrapper = document.querySelector('.supportive-care-wrapper');

        // 1. GET FLAGS FROM LOCAL STORAGE
        const userHasPigmentation = localStorage.getItem("hasPigmentation") === "true";
        const userHasDandruff = localStorage.getItem("hasDandruff") === "true";

        if (!container) return;
        
        container.innerHTML = '';
        
        // MASK ID = 51588893835576
        // SHAMPOO ID = 50944516981048
        // BRILANTE ID = 51599016362296
        
        supportiveCareProductIds.forEach(id => {
            
            // --- LOGIC FOR SHAMPOO (50944516981048) ---
            // Only show if user has Dandruff
            if (id === "50944516981048") {
                if (!userHasDandruff) return; // Skip if no dandruff
            }

            // --- LOGIC FOR BRILANTE SERUM (51599016362296) ---
            // Only show if user has Pigmentation
            if (id === "51599016362296") {
                if (!userHasPigmentation) return; // Skip if no pigmentation
            }
            
            // Check if this product is currently active in the Main Product Grid
            // (If the user clicked "Add", it moves to main grid and should disappear from here)
            const isAlreadyInMain = document.querySelector(`.product-card[data-variant-id="${id}"]`);
            
            // Render in supportive list ONLY IF not in main list AND data exists
            if (!isAlreadyInMain && allProductInfo[id]) {
                container.insertAdjacentHTML('beforeend', createSupportiveCardHtml(id, allProductInfo[id]));
            }
        });
        
        // Toggle visibility of the whole section
        if (container.innerHTML === '') {
            if(sectionWrapper) sectionWrapper.style.display = 'none';
        } else {
            if(sectionWrapper) sectionWrapper.style.display = 'block';
        }
    }

   function renderProducts(ids, container, mobile) {
    if (!container) return;
    container.innerHTML = ids.length ? '' : '<p>No specific products recommended.</p>';
    ids.forEach(id => {
        // We removed the block. If it is in LocalStorage, it should render in the main grid.
        if (allProductInfo[id]) {
            container.insertAdjacentHTML('beforeend', createProductCardHtml(id, allProductInfo[id], mobile));
        }
    });
} 
// --- UPDATED RENDERING LOGIC WITH PREGNANCY OVERRIDE ---
const isPregnancyPath = window.location.pathname.includes('/pages/hindi-women-pregnancy-motherhood-recommedation-page');

if (isPregnancyPath) {
    const pregnancyProductIds = [
        "51219366641976", // Aziderm 10%
        // "51219366740280", // Aziderm 20%
        "51219367297336", // Benzac AC
        "51219360317752", // Episoft-CL
        "51219355107640", // Venusia Derm
        "51219358875960"  // UV Doux
    ];
    
    // Force these products into the view, ignoring local storage
    renderProducts(pregnancyProductIds, mobileProductGrid, true);
    renderProducts(pregnancyProductIds, desktopProductGrid, false);
    
    // Hide supportive care for this specific page if required
    const supportiveWrapper = document.querySelector('.supportive-care-wrapper');
    if (supportiveWrapper) supportiveWrapper.style.display = 'none';

} else {
    // Normal logic for other pages
    renderProducts(skinProductIds, mobileProductGrid, true);
    renderProducts(skinProductIds, desktopProductGrid, false);
}
   
  

    // =========================================================
    // 5. EVENT LISTENERS
    // =========================================================

    // A. ADD FROM SUPPORTIVE LIST
   // A. ADD FROM SUPPORTIVE LIST
document.addEventListener('click', function (e) {
    const addBtn = e.target.closest('.supportive-card-add-btn');
    if (!addBtn) return;
    
    const card = addBtn.closest('.supportive-care-card');
    if (!card) return;
    
    const productId = card.dataset.productId;
    const productData = allProductInfo[productId];
    if (!productData) return;

    // 1. Add to main grids at the TOP ('afterbegin')
    if (mobileProductGrid) mobileProductGrid.insertAdjacentHTML('afterbegin', createProductCardHtml(productId, productData, true));
    if (desktopProductGrid) desktopProductGrid.insertAdjacentHTML('afterbegin', createProductCardHtml(productId, productData, false));

    // 2. SAVE TO LOCAL STORAGE (This is the new part)
    let currentSkinIds = JSON.parse(localStorage.getItem('skinProductIds') || '[]');
    if (!currentSkinIds.includes(productId)) {
        currentSkinIds.unshift(productId); // Add to the top of the list
        localStorage.setItem('skinProductIds', JSON.stringify(currentSkinIds));
    }

    // 3. Re-calculate view (Removes from supportive list)
    refreshSupportiveSection();
    updateProductSummary();
});

    // B. REMOVE PRODUCT (Trash Icon)
 
// B. REMOVE PRODUCT (Trash Icon)
document.addEventListener('click', (e) => {
    if (e.target.closest('.remove-product-button')) {
        const card = e.target.closest('.product-card');
        if (card) {
            const id = card.dataset.variantId;
            document.querySelectorAll(`.product-card[data-variant-id="${id}"]`).forEach(c => c.remove());
            
            // REMOVE FROM LOCAL STORAGE (New Part)
            let currentSkinIds = JSON.parse(localStorage.getItem('skinProductIds') || '[]');
            currentSkinIds = currentSkinIds.filter(item => item !== id);
            localStorage.setItem('skinProductIds', JSON.stringify(currentSkinIds));

            refreshSupportiveSection();
            updateProductSummary();
        }
    }
});
    // C. QUANTITY CHANGE (+ / -)
    document.addEventListener('click', function (e) {
        const qtyWrapper = e.target.closest('.product-qty-wrapper');
        if (!qtyWrapper) return;
        const card = qtyWrapper.closest('.product-card');
        if (!card) return;
        const id = card.dataset.variantId;
        
        if (!supportiveCareProductIds.includes(id)) return;

        let qty = parseInt(qtyWrapper.dataset.qty || '1', 10);

        if (e.target.closest('.plus') && qty < 20) {
            qty++;
        }
        if (e.target.closest('.minus')) {
            if (qty > 1) {
                qty--;
            } 
            else {
                // QTY < 1: Remove from main grid, put back in supportive
                document.querySelectorAll(`.product-card[data-variant-id="${id}"]`).forEach(c => c.remove());
                
                // ADD THIS LOCAL STORAGE UPDATE HERE:
                let currentSkinIds = JSON.parse(localStorage.getItem('skinProductIds') || '[]');
                currentSkinIds = currentSkinIds.filter(item => item !== id);
                localStorage.setItem('skinProductIds', JSON.stringify(currentSkinIds));
                // -----------------------------------

                refreshSupportiveSection();
                updateProductSummary();
                return;
            } 
        }
        qtyWrapper.dataset.qty = qty;
        card.dataset.qty = qty;
        qtyWrapper.querySelector('.product-qty-value').textContent = qty;
        updateProductSummary();
    });
// D. SUPPORTIVE CARE SCROLL NAV
   const supportiveScrollContainer = document.querySelector('.supportive-care-scroll');
   const supportivePrevBtn = document.querySelector('.supportive-header-nav .prev-btn');
   const supportiveNextBtn = document.querySelector('.supportive-header-nav .next-btn');
   const supportiveNavBtns = document.querySelectorAll('.supportive-header-nav .supportive-nav-btn');

   // Helper to calculate scroll distance (card width + gap)
   function getSupportiveScrollDistance() {
       if (!supportiveScrollContainer) return 300;
       const card = supportiveScrollContainer.querySelector('.supportive-care-card');
       if (!card) return 300; // Fallback default

       const containerStyle = window.getComputedStyle(supportiveScrollContainer);
       // Try to get gap from CSS, default to 16px if not found
       let gapStr = containerStyle.gap || containerStyle.columnGap || '16px';
       let gap = parseFloat(gapStr);
       if (isNaN(gap)) gap = 16;

       return card.offsetWidth + gap;
   }

   // Prev Button Click
   if (supportivePrevBtn && supportiveScrollContainer) {
       supportivePrevBtn.addEventListener('click', function() {
           // Highlight active button
           supportiveNavBtns.forEach(b => b.classList.remove('active'));
           this.classList.add('active');
           // Scroll left
           supportiveScrollContainer.scrollBy({ left: -getSupportiveScrollDistance(), behavior: 'smooth' });
       });
   }

   // Next Button Click
   if (supportiveNextBtn && supportiveScrollContainer) {
       supportiveNextBtn.addEventListener('click', function() {
           // Highlight active button
           supportiveNavBtns.forEach(b => b.classList.remove('active'));
           this.classList.add('active');
           // Scroll right
           supportiveScrollContainer.scrollBy({ left: getSupportiveScrollDistance(), behavior: 'smooth' });
       });
   }
    // =========================================================
    // 6. CALCULATIONS & CHECKOUT
    // =========================================================
    function updateComplimentaryServices(totalAmount) {
        const listEl = document.getElementById('complimentary-services-list');
        const sectionEl = document.getElementById('complimentary-services-section');
        if (!listEl || !sectionEl) return;

        const checkIcon = ` <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="transparent"><circle cx="10" cy="10" r="10" fill="#2F444E"/><path d="M5 9.16667L7.77926 12.5L15 7.5" stroke="#EEF2F4" stroke-width="2" stroke-linecap="round"/></svg>`;
        let services = [];
        if (totalAmount >= 3000) services = ['Personalised Diet Plan', 'WhatsApp Doctor Support', 'Free Follow-up Consultation', 'Skin Care Routine PDF'];
        else if (totalAmount >= 2000) services = ['Personalised Diet Plan', 'WhatsApp Doctor Support', 'Free Follow-up Consultation'];
        else if (totalAmount >= 1000) services = ['Personalised Diet Plan', 'WhatsApp Doctor Support'];
        else if (totalAmount > 0) services = ['Personalised Diet Plan'];

        if (services.length === 0) {
            sectionEl.style.display = 'none';
            listEl.innerHTML = '';
            return;
        }
        sectionEl.style.display = 'block';
        listEl.innerHTML = services.map(s => `<li class="complimentary-item">${checkIcon}<span>${s}</span></li>`).join('');
    }

    function updateProductSummary() {
        let total = 0;
        let totalItems = 0;
        const gridsToCheck = [mobileProductGrid, desktopProductGrid].filter(Boolean);
        const countedProductIds = new Set();

        gridsToCheck.forEach(grid => {
            grid.querySelectorAll('.product-card').forEach(card => {
                const variantId = card.dataset.variantId;
                if (!variantId || countedProductIds.has(variantId)) return;
                countedProductIds.add(variantId);
                const unitPrice = parseFloat(card.dataset.price || 0);
                const qty = parseInt(card.dataset.qty || '1', 10);
                if (!isNaN(unitPrice) && qty > 0) {
                    total += unitPrice * qty;
                    totalItems += qty;
                }
            });
        });

        document.querySelectorAll('.item-total-section .item-price, .subtotal-price, .current-price').forEach(el => el.textContent = `₹${total}`);
        updateComplimentaryServices(total);
        document.querySelectorAll('#item-count, #item-count-desktop').forEach(el => el.textContent = totalItems);
        document.querySelectorAll('.item-count-unit').forEach(el => el.textContent = totalItems === 1 ? 'item' : 'items');

        const originalPrice = totalItems > 0 ? total + 2500 : 0;
        const savedValue = originalPrice - total;
        document.querySelectorAll('.original-price').forEach(el => el.textContent = `₹${originalPrice}`);
        document.querySelectorAll('.saved-price').forEach(el => el.textContent = `₹${savedValue}`);

        const badgeEl = document.getElementById('dynamic-discount-badge');
        if (badgeEl && totalItems > 0 && originalPrice > total) {
            const percentage = Math.round((savedValue / originalPrice) * 100);
            badgeEl.textContent = `SAVE ${percentage}%`;
            badgeEl.style.display = 'block';
        } else if (badgeEl) {
            badgeEl.style.display = 'none';
        }

        document.querySelectorAll('.no-items-card').forEach(el => el.style.display = totalItems > 0 ? 'none' : 'flex');
        document.querySelectorAll('.buy-button, #buy-now-mobile, #buy-now-desktop').forEach(btn => {
            btn.disabled = totalItems === 0;
            btn.style.opacity = totalItems === 0 ? 0.6 : 1;
            btn.style.cursor = totalItems === 0 ? 'not-allowed' : 'pointer';
        });
    }

  
 function sendDataToGoogleSheet(cartItems, totalPrice) {
    const scriptURL = 'https://script.google.com/macros/s/AKfycbyQ1NBIBlh3-bX9_ZTL66O-RH1Rk5lUB9tBygrOaHLJ_Z2FlzNztpbI-Y0nK7UQIBRg/exec';
    
    // 1. Retrieve User Info
    const firstName = localStorage.getItem('userFirstname') || 'N/A';
    const phone = localStorage.getItem('kylas_user_phone') || localStorage.getItem('userPhone') || 'N/A';
    
    // 2. Retrieve Diagnosis Info (Ensure keys match your localStorage set in onSubmit)
    const skinDiagnosis = localStorage.getItem('skinDiagnosis') || 'N/A';
    const rootDiagnosis = localStorage.getItem('ayurvedaDiagnosis') || 'N/A';
    
    // 3. Retrieve Women's Specific Acne Data if available
    const womenAcneTypes = JSON.parse(localStorage.getItem('userAcneSelections') || '[]');
    const womenAcneString = womenAcneTypes.length > 0 ? ` (Acne Types: ${womenAcneTypes.join(', ')})` : '';

    // 4. Map Cart Items to Titles
    const productNames = cartItems.map(item => {
        return allProductInfo[item.id] ? allProductInfo[item.id].title : item.id;
    }).join(', ');

    // 5. Build FormData
    const formData = new FormData();
    formData.append('SheetName', 'hindi');
    formData.append('Name', firstName);
    formData.append('Phone', phone);
    formData.append('SkinDiagnosis', skinDiagnosis);
    formData.append('RootDiagnosis', rootDiagnosis + womenAcneString); // Combined Ayurveda + Visual Acne
    formData.append('RecommendationList', productNames);
    formData.append('TotalPrice', totalPrice);
    formData.append('Timestamp', new Date().toLocaleString());

    console.log("Sending to Sheets:", Object.fromEntries(formData));

    // 6. Execute Fetch
    fetch(scriptURL, { 
        method: 'POST', 
        body: formData, 
        mode: 'no-cors' 
    })
    .then(() => console.log("Google Sheet Sync Successful"))
    .catch(e => console.error("Google Sheet Sync Failed:", e));
}
    function handleCheckout(e) {
        // 1. Prevent default action and get the clicked button
        if (e) e.preventDefault();
        const clickedBtn = e.target.closest('button') || e.target;
        const originalText = clickedBtn.textContent; // Store text to revert if error

        // 2. DISABLE BUTTONS & SHOW LOADING MESSAGE
        // We disable ALL buy buttons to ensure they don't click desktop while mobile is loading etc.
        const allBuyBtns = document.querySelectorAll('.buy-button, #buy-now-mobile, #buy-now-desktop');
        
        allBuyBtns.forEach(btn => {
            btn.disabled = true; // Prevent multiple clicks
            btn.style.opacity = '0.6'; // Visual feedback that it's disabled
            btn.style.cursor = 'wait'; // Show wait cursor
        });

        // Change text specifically on the button clicked
        clickedBtn.textContent = "Please wait...";

        // 3. GATHER ITEMS (Existing Logic)
        const items = [];
        const added = new Set();
        let calculatedTotal = 0;
        const gridsToCheck = [mobileProductGrid, desktopProductGrid].filter(Boolean);

        gridsToCheck.forEach(grid => {
            grid.querySelectorAll('.product-card').forEach(c => {
                const id = c.dataset.variantId;
                if (!id || added.has(id)) return;
                added.add(id);
                const price = parseFloat(c.dataset.price || 0);
                const qty = parseInt(c.dataset.qty || '1', 10);
                items.push({ id: id, quantity: qty });
                calculatedTotal += price * qty;
            });
        });

        // 4. VALIDATION: If empty, re-enable buttons
        if (!items.length) {
            alert('Cart is empty');
            allBuyBtns.forEach(btn => {
                btn.disabled = false;
                btn.style.opacity = '1';
                btn.style.cursor = 'pointer';
            });
            clickedBtn.textContent = originalText;
            return;
        }

        // 5. SEND DATA & PROCESS CART
        sendDataToGoogleSheet(items, calculatedTotal);

        fetch('/cart/clear.js', { method: 'POST' })
            .then(() => fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items })
            }))
            .then(() => {
                // 6. SUCCESS: Wait 1.5 seconds so user sees "Please wait", then redirect
                setTimeout(() => {
                    window.location.href = '/checkout';
                }, 1500); 
            })
            .catch(() => {
                alert('Error adding to cart');
                // Re-enable buttons if there was an error
                allBuyBtns.forEach(btn => {
                    btn.disabled = false;
                    btn.style.opacity = '1';
                    btn.style.cursor = 'pointer';
                });
                clickedBtn.textContent = originalText;
            });
    }

    // Keep your event listener as is, it automatically passes 'e'
    
    document.querySelectorAll('.buy-button, #buy-now-mobile, #buy-now-desktop').forEach(b => b.addEventListener('click', handleCheckout));

 

   

    // =========================================================
    // 7. POPUP LOGIC
    // =========================================================
    const overlay = document.getElementById('product-popup-overlay');
    const popupContainer = document.getElementById('product-popup-container');
    const closeBtns = document.querySelectorAll('#popup-close-btn, #popup-close-btn-bottom');
    let savedScrollPosition = 0;

    function showPopup() {
        if (overlay) overlay.classList.add('visible');
        if (popupContainer) {  popupContainer.classList.add('visible'); popupContainer.scrollTop = 0; } 
        savedScrollPosition = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${savedScrollPosition}px`;
        document.body.style.width = '100%';
    }

    function hidePopup() {
        if (overlay) overlay.classList.remove('visible');
        if (popupContainer) popupContainer.classList.remove('visible');
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, savedScrollPosition);
    }
    closeBtns.forEach(b => b.addEventListener('click', hidePopup));
    if (overlay) overlay.addEventListener('click', hidePopup);
function handleProductCardClick(event) {
        const card = event.target.closest('.product-card');

        // 1. Safety Check: Ensure we aren't clicking delete or quantity buttons
        if (card && !event.target.closest('.remove-product-button') && !event.target.closest('.product-qty-wrapper')) {
            event.preventDefault();
            const id = card.dataset.variantId;
            const data = allProductInfo[id];

            if (!data) return;

            // --- ICONS ---
            const benefitCheckIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="transparent"><circle cx="6" cy="6" r="6" fill="#4CAF50"/><path d="M3 5.82872L4.63947 7.32353L8.64706 4.5" stroke="white" stroke-linecap="round" fill="transparent"/ ></svg>`;
            const standardCheckIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 20" fill="transparent"><circle cx="10" cy="10" r="10" fill="#2F444E"/><path d="M5 9.16667L7.77926 12.5L15 7.5" stroke="#EEF2F4" stroke-width="2" stroke-linecap="round" fill="transparent"/></svg>`;
           
            const accordionPlus = `<svg class="icon-plus" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="transparent"><path d="M9.92454 19.5428V10.839H0.457245C0.204758 10.839 6.92713e-05 10.6343 0 10.3818C2.21915e-08 10.1293 0.204716 9.92454 0.457245 9.92454H9.92454V0.457245C9.92454 0.204716 10.1293 0 10.3818 0C10.6343 6.88006e-05 10.839 0.204758 10.839 0.457245V9.92454H19.5428C19.7952 9.92459 20 10.1293 20 10.3818C19.9999 10.6342 19.7952 10.839 19.5428 10.839H10.839V19.5428C10.839 19.7952 10.6342 19.9999 10.3818 20C10.1293 20 9.92459 19.7952 9.92454 19.5428Z" fill="#2F444E"/></svg>`;
            const accordionMinus = `<svg class="icon-minus" xmlns="http://www.w3.org/2000/svg" width="19" height="1" viewBox="0 0 19 1" fill="transparent"><path d="M0.5 0.5H18.5" stroke="#2F444E" stroke-linecap="round"/></svg>`;
            const leafIcon = `<mask id="mask0_leaf_unique" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14"><rect width="14" height="14" fill="#D9D9D9"/></mask><g mask="url(#mask0_leaf_unique)"><path d="M3.35328 11.2286C2.94193 10.8154 2.62071 10.3403 2.38961 9.80323C2.15852 9.26617 2.04297 8.71094 2.04297 8.13752C2.04297 7.56245 2.15312 6.99185 2.37343 6.42573C2.59364 5.8596 2.94942 5.33086 3.44078 4.8395C4.06524 4.21504 4.94904 3.77919 6.09218 3.53196C7.23522 3.28482 8.53294 3.18371 9.98534 3.22862C10.1857 3.24204 10.3685 3.28613 10.5338 3.36089C10.6991 3.43576 10.8438 3.53521 10.968 3.65927C11.0921 3.78342 11.1888 3.9278 11.2579 4.09239C11.3271 4.25689 11.3666 4.43559 11.3763 4.62848C11.3957 5.32099 11.3814 5.99294 11.3331 6.64433C11.2849 7.29572 11.1978 7.90112 11.0717 8.46054C10.9457 9.01996 10.777 9.52794 10.5658 9.9845C10.3545 10.4411 10.0907 10.8275 9.77432 11.1439C9.29269 11.6293 8.7776 11.9836 8.22907 12.2069C7.68055 12.4301 7.12497 12.5417 6.56234 12.5417C5.9725 12.5417 5.393 12.4261 4.82386 12.195C4.25473 11.9639 3.76453 11.6418 3.35328 11.2286ZM4.66126 11.1326C4.95439 11.3167 5.26418 11.4517 5.59066 11.5376C5.91713 11.6237 6.24151 11.6667 6.5638 11.6667C7.01355 11.6667 7.45839 11.5777 7.89832 11.3997C8.33835 11.2217 8.75577 10.9315 9.15059 10.5292C9.32491 10.3542 9.50166 10.1087 9.68084 9.79273C9.85993 9.47676 10.0149 9.06356 10.1456 8.55314C10.2764 8.04273 10.3756 7.42537 10.4434 6.70106C10.5112 5.97676 10.5245 5.11391 10.4834 4.11252C10.007 4.09307 9.46793 4.08763 8.86622 4.09619C8.26461 4.10484 7.66446 4.15384 7.06576 4.24319C6.46716 4.33253 5.90143 4.47258 5.36855 4.66333C4.83568 4.85398 4.40469 5.11386 4.07559 5.44296C3.64189 5.87676 3.3405 6.31596 3.17143 6.76056C3.00245 7.20516 2.91797 7.62676 2.91797 8.02537C2.91797 8.57653 3.0255 9.07499 3.24055 9.52075C3.45551 9.96642 3.67927 10.2973 3.91182 10.5134C4.23791 9.78058 4.69616 9.07742 5.28659 8.40396C5.87702 7.7305 6.6251 7.14289 7.53082 6.64112C6.8457 7.23865 6.25896 7.8949 5.77061 8.60987C5.28227 9.32475 4.91248 10.1657 4.66126 11.1326Z" fill="#4F5147"/></g>`;
            const shieldIcon = `<mask id="mask0_4878_606" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14"><rect width="14" height="14" fill="#D9D9D9"/></mask><g mask="url(#mask0_4878_606)"><path d="M2.16041 11.6084C2.0275 11.6084 1.91614 11.5634 1.8263 11.4735C1.73637 11.3836 1.69141 11.2723 1.69141 11.1394V6.83143C1.69141 6.57137 1.78323 6.3497 1.96689 6.16644C2.15054 5.98327 2.37133 5.89168 2.62926 5.89168H5.28795C5.35659 5.89168 5.41823 5.90534 5.47286 5.93266C5.5275 5.95998 5.57296 5.99177 5.60922 6.02804C5.64558 6.0643 5.67737 6.10975 5.70459 6.16439C5.73191 6.21903 5.74557 6.28072 5.74557 6.34946V7.00002C5.74557 7.34837 5.86744 7.6445 6.11118 7.88843C6.35491 8.13227 6.65086 8.25418 6.99901 8.25418C7.34726 8.25418 7.64345 8.13227 7.88757 7.88843C8.1318 7.6445 8.25391 7.34837 8.25391 7.00002V6.34946C8.25391 6.28072 8.26757 6.21903 8.29489 6.16439C8.32211 6.10975 8.3539 6.0643 8.39026 6.02804C8.42652 5.99177 8.47368 5.95998 8.53172 5.93266C8.58976 5.90534 8.6497 5.89168 8.71153 5.89168H11.3702C11.6281 5.89168 11.8489 5.98351 12.0326 6.16716C12.2162 6.35082 12.3081 6.57161 12.3081 6.82954V11.1391C12.3081 11.2731 12.2631 11.3848 12.1732 11.4742C12.0833 11.5636 11.972 11.6084 11.8391 11.6084H2.16041ZM2.44974 10.85H11.5497V6.82954C11.5497 6.77714 11.5329 6.73411 11.4993 6.70048C11.4656 6.66684 11.4226 6.65002 11.3702 6.65002H9.01224V7.00002C9.01224 7.55817 8.81575 8.0331 8.42278 8.42481C8.02971 8.81662 7.55439 9.01252 6.99682 9.01252C6.43925 9.01252 5.96496 8.81628 5.57393 8.42379C5.1828 8.0314 4.98724 7.55681 4.98724 7.00002V6.65002H2.62926C2.57686 6.65002 2.53384 6.66684 2.5002 6.70048C2.46656 6.73411 2.44974 6.77714 2.44974 6.82954V10.85ZM6.99959 7.24793C6.89207 7.24793 6.80204 7.21298 6.72951 7.14308C6.65689 7.07318 6.62057 6.9866 6.62057 6.88335C6.57196 5.90607 6.65907 4.9479 6.88191 4.00883C7.10484 3.06986 7.58234 2.28139 8.31443 1.64341C8.39153 1.57614 8.48277 1.54609 8.58816 1.55329C8.69364 1.56039 8.78304 1.60336 8.85634 1.6822C8.92732 1.75736 8.95833 1.84855 8.94939 1.95579C8.94034 2.06312 8.89548 2.15159 8.81478 2.22121C8.15814 2.76118 7.75467 3.45418 7.60437 4.30021C7.45406 5.14633 7.37891 5.99766 7.37891 6.85418C7.37891 6.96162 7.34182 7.05164 7.26764 7.12427C7.19346 7.19699 7.10411 7.23821 6.99959 7.24793ZM3.49872 8.72756C3.59302 8.72756 3.67139 8.69674 3.7338 8.6351C3.79612 8.57336 3.82728 8.49534 3.82728 8.40104C3.82728 8.30673 3.79646 8.22837 3.73482 8.16596C3.67309 8.10364 3.59507 8.07248 3.50076 8.07248C3.40646 8.07248 3.32809 8.1033 3.26568 8.16493C3.20336 8.22667 3.1722 8.30469 3.1722 8.399C3.1722 8.4933 3.20302 8.57166 3.26466 8.63408C3.32639 8.6964 3.40441 8.72756 3.49872 8.72756ZM4.54872 10.1276C4.64302 10.1276 4.72139 10.0967 4.7838 10.0351C4.84612 9.97336 4.87728 9.89534 4.87728 9.80104C4.87728 9.70673 4.84646 9.62837 4.78482 9.56596C4.72309 9.50364 4.64507 9.47248 4.55076 9.47248C4.45646 9.47248 4.37809 9.50329 4.31568 9.56493C4.25336 9.62667 4.2222 9.70469 4.2222 9.799C4.2222 9.8933 4.25302 9.97166 4.31466 10.0341C4.37639 10.0964 4.45441 10.1276 4.54872 10.1276ZM10.4987 8.72756C10.593 8.72756 10.6714 8.69674 10.7338 8.6351C10.7961 8.57336 10.8273 8.49534 10.8273 8.40104C10.8273 8.30673 10.7965 8.22837 10.7348 8.16596C10.6731 8.10364 10.5951 8.07248 10.5008 8.07248C10.4065 8.07248 10.3281 8.1033 10.2657 8.16493C10.2034 8.22667 10.1722 8.30469 10.1722 8.399C10.1722 8.4933 10.203 8.57166 10.2647 8.63408C10.3264 8.6964 10.4044 8.72756 10.4987 8.72756Z" fill="#2F444E"/></g></mask>`;

            
             // --- POPULATE BASIC INFO ---
            document.getElementById('popup-title').innerHTML = data.title;
            document.getElementById('popup-description').innerHTML = data.description;
            
            // --- PRICE & QUANTITY ROW (Matches Image Format: ₹350 | 1 Unit) ---
            const priceEl = document.getElementById('popup-price');
            
            // Apply specific styles to match the grey, light-weight look from the image
            priceEl.style.color = '#5E6B77'; 
            priceEl.style.fontWeight = '300';
            priceEl.style.fontSize = '16px';
            priceEl.style.fontFamily = 'Nacelle';
            priceEl.style.marginTop = '4px'; 
            priceEl.style.marginBottom = '12px';

            if (data.quantityLabel) {
                // Combine Price + Separator + Quantity
                priceEl.innerHTML = `₹${data.price} &nbsp;<span style="color: #B5BBC0; font-weight:300!important;">|</span>&nbsp; ${data.quantityLabel}`;
            } else {
                // Standard Product (Price Only)
                priceEl.innerHTML = `₹${data.price}`;
            }

            // (Cleanup) Hide the standalone quantity label if it was created by previous script versions
            const oldQtyEl = document.getElementById('popup-quantity-label');
            if (oldQtyEl) oldQtyEl.style.display = 'none';

            // --- DETERMINE LAYOUT TYPE ---
            const supportiveIds = [
                "51588893835576", "51598963638584", "51599001846072", 
                "51599014691128", "51599016362296", "50944516981048"
            ];
            const isSupportive = supportiveIds.includes(id);

            const typeLabel = document.getElementById('popup-product-type');
            const typeBadge = document.querySelector('.product-type-badge');
            const badgeSvg = typeBadge ? typeBadge.querySelector('svg') : null;
            let benefitsContainer = document.getElementById('popup-benefits-container');

            if (!benefitsContainer) {
                benefitsContainer = document.createElement('div');
                benefitsContainer.id = 'popup-benefits-container';
                const detailsContainer = document.querySelector('.popup-details-container');
                if(detailsContainer) detailsContainer.parentNode.insertBefore(benefitsContainer, detailsContainer.nextSibling);
            }

            if (isSupportive) {
                
                // --- SUPPORTIVE MODE ---
                if (typeBadge) {
                    typeBadge.style.display = 'inline-flex';
                    typeBadge.classList.add('supportive-style');
                    typeLabel.innerText = "Supportive Care";
                    if (badgeSvg) badgeSvg.style.display = 'none';
                }
                
                // Show Benefits
                if (data.benefits && data.benefits.length > 0) {
                    let html = `<h4 class="popup-benefits-title" style="color: #2F2F2F; font-family: Nacelle; font-size: 16px; font-weight: 600; text-transform: uppercase; margin: 16px 0 8px 0;">BENEFITS</h4><div class="popup-benefits-grid" style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 6px;">`;
                    data.benefits.forEach(benefit => {
                        html += `
                        <div style="display: flex; width: auto; padding: 4px 8px; justify-content: center; align-items: center; gap: 6px; border-radius: 6px; background: var(--Alias-success-success-50, #EDF7EE);">
                            ${benefitCheckIcon}
                            <span style="color: var(--Alias-success-success-500, #4CAF50); font-family: Nacelle, sans-serif; font-size: 0.75rem; font-weight: 300; white-space: nowrap;">${benefit}</span>
                        </div>`;
                    });
                    html += `</div>`;
                    benefitsContainer.innerHTML = html;
                    benefitsContainer.style.display = 'block';
                } else {
                    benefitsContainer.style.display = 'none';
                }

                // Hide standard sections
                const activeIng = document.getElementById('popup-active-ingredients-container');
                if (activeIng) activeIng.style.display = 'none';
                const clinical = document.getElementById('popup-studies-section');
                if (clinical) clinical.style.display = 'none';

            } else {
                // --- STANDARD MODE ---
                if (typeBadge) {
                    typeBadge.classList.remove('supportive-style');
                    typeBadge.style.display = 'inline-flex';
                    typeBadge.style.background = (data.product_used === 'Ayurveda') ? '#E0E2D8' : '#D9EBF0';
                    typeLabel.innerText = (data.product_used === 'Ayurveda') ? "Target root cause" : (data.product_used || "Dermatology");
                    typeLabel.style.color = (data.product_used === 'Ayurveda') ? '#4F5147' : '#2F444E';
                    if (badgeSvg) badgeSvg.style.display = 'block';
                    if (badgeSvg) badgeSvg.innerHTML = (data.product_used === 'Ayurveda') ? leafIcon : shieldIcon;
                }
                benefitsContainer.style.display = 'none';

                // Show standard sections
                const activeIng = document.getElementById('popup-active-ingredients-container');
                if (activeIng && data.activeIngredients) activeIng.style.display = 'block';
                const clinical = document.getElementById('popup-studies-section');
                if (clinical && data.clinicalImage) clinical.style.display = 'block';
            }

            // --- ACCORDIONS ---
            const accordionContainer = document.querySelector('.popup-accordion');
            if (accordionContainer) {
                accordionContainer.innerHTML = '';
                const createItem = (title, contentHTML) => {
                    const item = document.createElement('div');
                    item.className = 'popup-accordion-item';
                    item.innerHTML = `
                        <div class="popup-accordion-header">
                            <span>${title}</span>
                            <span class="popup-accordion-toggle">${accordionPlus}${accordionMinus}</span>
                        </div>
                        <div class="popup-accordion-content" style="max-height: 0;">${contentHTML}</div>`;
                    
                    item.querySelector('.popup-accordion-header').addEventListener('click', () => {
                        item.classList.toggle('active');
                        const content = item.querySelector('.popup-accordion-content');
                        if (item.classList.contains('active')) {
                            content.style.maxHeight = content.scrollHeight + "px";
                            content.style.paddingTop = "2vw";
                            content.style.paddingBottom = "4vw";
                        } else {
                            content.style.maxHeight = "0";
                            content.style.paddingTop = "0";
                            content.style.paddingBottom = "0";
                        }
                    });
                    return item;
                };

                if (isSupportive) {
                   let usageHtml = '';
                
                // Common styling for the Ordered List (<ol>)
                const listStyle = "margin: 0; padding-left: 20px; list-style-type: decimal !important; color: #2F2F2F; font-family: Nacelle; font-size: 14px; font-weight: 300!important; line-height: 1.6;";

                // Check if data.howToUse is an Array (e.g. ["Step 1", "Step 2"])
                if (Array.isArray(data.howToUse)) {
                    usageHtml = `<ol style="${listStyle}">`;
                    data.howToUse.forEach(step => {
                        // Remove any <br> tags inside the step text itself if they exist
                        let cleanStep = step.replace(/<br\s*\/?>/gi, ''); 
                        // FIX: Use += to append, and add the <li> tag
                        usageHtml += `<li style="margin-bottom: 8px; padding-left: 5px; font-weight: 300!important;">${cleanStep}</li>`;
                    });
                    usageHtml += `</ol>`;
                } 
                // Handle case where it's a String containing <br> tags
                else if (typeof data.howToUse === 'string' && data.howToUse.includes('<br>')) {
                     const steps = data.howToUse.split(/<br\s*\/?>/i).map(s => s.trim()).filter(s => s !== '');
                     
                     if(steps.length > 0) {
                         usageHtml = `<ol style="${listStyle}">`;
                         steps.forEach(step => {
                            usageHtml += `<li style="margin-bottom: 8px; padding-left: 5px; font-weight: 300!important;">${step}</li>`;
                         });
                         usageHtml += `</ol>`;
                     } else {
                         usageHtml = `<p>${data.howToUse}</p>`;
                     }
                }
                else {
                    // Fallback for simple string or missing data
                    usageHtml = `<p style="color: #2F2F2F; font-family: Nacelle; font-size: 14px; font-weight: 300; line-height: 1.6;">${data.howToUse || "Follow instructions on the package."}</p>`;
                }

                accordionContainer.appendChild(createItem("HOW TO USE", usageHtml));
                    accordionContainer.appendChild(createItem("COMPOSITION", `<p>${data.composition || ''}</p>`));
                    const detailsHTML = `<strong>BEST SUITED FOR:</strong><p>${data.bestSuitedFor || ''}</p><hr><strong>PRODUCT FORM:</strong><p>${data.productForm || ''}</p><hr><strong>AREA OF APPLICATION:</strong><p>${data.areaOfApplication || ''}</p>`;
                    accordionContainer.appendChild(createItem("PRODUCT DETAILS", detailsHTML));
                } else {
                    accordionContainer.appendChild(createItem("COMPOSITION", `<span>${data.composition || ''}</span>`));
                    const detailsHTML = `<strong>BEST SUITED FOR:</strong><p>${data.bestSuitedFor || ''}</p><hr><strong>PRODUCT FORM:</strong><p>${data.productForm || ''}</p><hr><strong>AREA OF APPLICATION:</strong><p>${data.areaOfApplication || ''}</p>`;
                    accordionContainer.appendChild(createItem("PRODUCT DETAILS", detailsHTML));
                    
                    // Render Ingredients (Standard Only)
                    const ingContainer = document.getElementById('popup-active-ingredients-container');
                    const ingTrack = document.getElementById('popup-ingredients-scroll-track');
                    if (ingContainer && ingTrack && data.activeIngredients && data.activeIngredients.length > 0) {
                        ingContainer.style.display = 'block';
                        ingTrack.innerHTML = '';
                        if(data.activeIngredients[0].bgImage) ingContainer.style.background = "url('" + data.activeIngredients[0].bgImage + "') lightgray 50% / cover no-repeat";
                        data.activeIngredients.forEach((ing) => {
                            const c = document.createElement('div');
                            c.className = 'ingredient-card';
                            const tags = ing.tags ? ing.tags.map(t => `<span class="ingredient-tag">${standardCheckIcon} ${t}</span>`).join('') : '';
                            c.innerHTML = `<h4 class="ingredient-name">${ing.name}</h4><p class="ingredient-desc">${ing.desc}</p><div class="ingredient-good-for-section"><span class="good-for-label">Good for</span><div class="ingredient-tags-grid">${tags}</div></div>`;
                            ingTrack.appendChild(c);
                        });
                        // Observer Re-init
                        const observerOptions = { root: ingTrack, rootMargin: '0px -30% 0px -30%', threshold: 0.05 };
                        const obs = new IntersectionObserver((entries) => {
                            entries.forEach(entry => {
                                if (entry.isIntersecting) {
                                    ingTrack.querySelectorAll('.ingredient-card').forEach(c => c.classList.remove('active'));
                                    entry.target.classList.add('active');
                                    const idx = Array.from(ingTrack.children).indexOf(entry.target);
                                    if (idx !== -1 && data.activeIngredients[idx]) {
                                        ingContainer.style.backgroundImage = "url('" + data.activeIngredients[idx].bgImage + "')";
                                        ingContainer.style.backgroundColor = "transparent";
                                        ingContainer.style.backgroundSize = "cover";
                                        ingContainer.style.backgroundPosition = "center";
                                        ingContainer.style.backgroundRepeat = "no-repeat";
                                    }
                                }
                            });
                        }, observerOptions);
                        ingTrack.querySelectorAll('.ingredient-card').forEach(c => obs.observe(c));
                          const ingLeftBtn = document.getElementById('ingredients-nav-left');
                        const ingRightBtn = document.getElementById('ingredients-nav-right');

                        if (ingLeftBtn && ingRightBtn) {
                            if (data.activeIngredients.length <= 1) {
                                ingLeftBtn.style.display = 'none';
                                ingRightBtn.style.display = 'none';
                            } else {
                                ingLeftBtn.style.display = 'block';
                                ingRightBtn.style.display = 'block';
                                
                                ingLeftBtn.onclick = () => {
                                    ingTrack.scrollBy({ left: -280, behavior: 'smooth' });
                                };
                                ingRightBtn.onclick = () => {
                                    ingTrack.scrollBy({ left: 280, behavior: 'smooth' });
                                };
                            }
                        }
                    } else if (ingContainer) {
                        ingContainer.style.display = 'none';
                    }

                    // Render Clinical Studies (Standard Only)
                    const studiesSec = document.getElementById('popup-studies-section');
                    const studiesContent = document.getElementById('popup-studies-content');
                    if (studiesSec && studiesContent) {
                         if (data.clinicalImage) {
                             studiesContent.innerHTML = `<h3 class="popup-studies-title" style="margin-bottom:15px;"><strong>CLINICAL</strong> STUDIES</h3><img src="${data.clinicalImage}" style="width: 100%; border-radius: 8px;">`;
                             studiesSec.style.display = 'block';
                         } else {
                             studiesSec.style.display = 'none';
                         }
                    }
                }
            }

            // --- CAROUSEL & FAQ (Common) ---
           // --- CAROUSEL & FAQ (Common) ---
const track = document.getElementById('popup-scroll-track');
const dots = document.getElementById('popup-dots-container');

if (track && dots) {
    track.innerHTML = '';
    dots.innerHTML = '';

    const imgs = (data.images && data.images.length) ? data.images : [data.image];

    imgs.forEach((src, i) => {
        const img = document.createElement('img');
        img.src = src;
        img.className = 'popup-carousel-image';
        track.appendChild(img);

        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'contain';

        const dot = document.createElement('span');
        dot.className = 'popup-dot';
        if (i === 0) dot.classList.add('active');
        dots.appendChild(dot);
    });

    track.scrollLeft = 0;

    // ✅ ADD THIS PART (ACTIVE DOT SYNC)
    const dotEls = dots.querySelectorAll('.popup-dot');

    track.addEventListener('scroll', () => {
        const slideWidth = track.clientWidth;
        const index = Math.round(track.scrollLeft / slideWidth);

        dotEls.forEach((d, i) => {
            d.classList.toggle('active', i === index);
        });
    });
}

            const faqList = document.getElementById('popup-faq-list');
            const faqSec = document.getElementById('popup-faq-section');
            if (faqList && faqSec) {
                if (data.faqs && data.faqs.length) {
                    let html = '';
                   const faqDescEl = document.getElementById('popup-faq-description');

if (faqDescEl) {
  const cleanTitle = data.title
    .replace(/<br\s*\/?>/gi, ' ')   // remove <br>
    .replace(/\s+/g, ' ')          // normalize spaces
    .trim();

  faqDescEl.textContent = `Find out more about ${cleanTitle}`;
}

                    data.faqs.forEach(f => {
                        html += `<div class="popup-faq-item"><div class="popup-faq-header"><span class="popup-faq-question">${f.question}</span><span class="popup-faq-toggle">${faqPlusIcon}${faqMinusIcon}</span></div><div class="popup-faq-content"><p>${f.answer}</p></div></div>`;
                    });
                    faqList.innerHTML = html;
                    faqSec.style.display = 'block';
                    faqList.querySelectorAll('.popup-faq-header').forEach(h => {
                        h.addEventListener('click', () => {
                            const item = h.parentElement;
                            item.classList.toggle('active');
                            const c = h.nextElementSibling;
                            c.style.maxHeight = item.classList.contains('active') ? c.scrollHeight + 'px' : '0';
                        });
                    });
                } else {
                    faqSec.style.display = 'none';
                }
            }

            showPopup();
        }
    }
 
    if (mobileProductGrid) mobileProductGrid.addEventListener('click', handleProductCardClick);
    if (desktopProductGrid) desktopProductGrid.addEventListener('click', handleProductCardClick);
// =========================================================
// ADDITIONAL: SUPPORTIVE CARD IMAGE → OPEN EXISTING POPUP
// (Does NOT replace any existing logic)
// =========================================================
document.addEventListener('click', function (e) {
    const img = e.target.closest('.supportive-card-image');
    if (!img) return;

    const supportiveCard = img.closest('.supportive-care-card');
    if (!supportiveCard) return;

    const productId = supportiveCard.dataset.productId;
    if (!productId) return;

    // Create a TEMP dummy product-card to reuse existing popup logic
    const tempCard = document.createElement('div');
    tempCard.className = 'product-card';
    tempCard.dataset.variantId = productId;

    // Fake click event object to pass into existing handler
    handleProductCardClick({
        target: tempCard,
        preventDefault: () => {},
    });
});

    // =========================================================
    // 8. FINAL INITIALIZATION
    // =========================================================
    refreshSupportiveSection();
    updateProductSummary();
    // =========================================================
// HAPPY CUSTOMERS SCROLL → DOT SYNC
// =========================================================
const happyContainer = document.querySelector('.customers-scroll-container');
const happyDots = document.querySelectorAll('.happy-dot');

if (happyContainer && happyDots.length) {

    happyContainer.addEventListener('scroll', () => {
        const card = happyContainer.querySelector('.customer-testimonial-card');
        if (!card) return;

        const cardWidth = card.offsetWidth;
        const index = Math.round(happyContainer.scrollLeft / cardWidth);

        happyDots.forEach((dot, i) => {
            dot.classList.toggle('active', i === index);
        });
    });

    // OPTIONAL: Click dot → scroll
    happyDots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
            const card = happyContainer.querySelector('.customer-testimonial-card');
            if (!card) return;

            happyContainer.scrollTo({
                left: i * card.offsetWidth,
                behavior: 'smooth'
            });
        });
    });
}
// =========================================================
    // 9. RECOMMENDATION FAQ ACCORDION LOGIC
    // =========================================================
   const recFaqHeaders = document.querySelectorAll('.recommedation-faq-question');

    // 1. Initial Setup: Inject Plus Icon into all Recommendation FAQs on load
    recFaqHeaders.forEach(header => {
        const toggleSpan = header.querySelector('.recommedation-faq-toggle');
        if (toggleSpan) {
            toggleSpan.innerHTML = faqPlusIcon; // Set initial state
        }
    });

    // 2. Click Handler
    recFaqHeaders.forEach(header => {
        header.addEventListener('click', function() {
            const item = this.parentElement; 
            const answer = this.nextElementSibling; 
            const toggleSpan = this.querySelector('.recommedation-faq-toggle'); // DEFINED HERE

            // Toggle active class
            item.classList.toggle('active');

            // Handle Slide Animation & Icon Swap
            if (item.classList.contains('active')) {
                answer.style.maxHeight = (answer.scrollHeight + 30) + "px";
                answer.style.paddingTop = "10px";
                answer.style.paddingBottom = "15px";
                
                if(toggleSpan) toggleSpan.innerHTML = faqMinusIcon; // Uses global variable
            } else {
                answer.style.maxHeight = "0";
                answer.style.paddingTop = "0";
                answer.style.paddingBottom = "0";
                
                if(toggleSpan) toggleSpan.innerHTML = faqPlusIcon; // Uses global variable
            }
        });
    
   // =========================================================
// 10. WOMEN'S PAGE ACNE LOGIC (FIXED)
// =========================================================
// if (window.location.pathname.includes('/pages/women-recommedation-page') || window.location.pathname.includes('/pages/student-recommedation-page')) {
   
    const videoGrid = document.getElementById("doctor-video-grid");
    const dots = document.querySelectorAll(".video-dot");

    if (videoGrid && dots.length > 0) {
        videoGrid.addEventListener("scroll", () => {
            // Get the width of one video card + the gap (16px)
            const card = videoGrid.querySelector(".item-video-card");
            if (!card) return;
            
            // Calculate total width of one item including gap
            // We use card.offsetWidth plus the gap defined in CSS (16px)
            const itemWidth = card.offsetWidth + 16; 
            
            // Calculate which index we are currently scrolled to
            const scrollPosition = videoGrid.scrollLeft;
            const activeIndex = Math.round(scrollPosition / itemWidth);

            // Update dots classes
            dots.forEach((dot, index) => {
                if (index === activeIndex) {
                    dot.classList.add("active");
                } else {
                    dot.classList.remove("active");
                }
            });
        });
    }
    const fileInput = document.getElementById('fileInput');

if (fileInput) {
   fileInput.addEventListener('change', function(e) {
  if (this.files && this.files[0]) {
    const file = this.files[0];
    
    // Replace these with your actual input field values
   // CHANGE TO THIS:
const userName = localStorage.getItem('userFirstname') || "Unknown"; 
const phoneNumber = localStorage.getItem('userPhone') || "No-Phone";
    const customFileName = `${phoneNumber}-${userName}`; // Requirements

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function() {
      const base64Data = reader.result.split(',')[1];
      // Inside your reader.onload function:
const payload = {
  base64: base64Data,
  mimeType: file.type,
  fileName: customFileName,
  userName: userName,
  phone: phoneNumber
};

// Use standard text/plain or no content-type to avoid OPTIONS pre-flight
fetch('https://script.google.com/macros/s/AKfycbwi0RP729-kOsb7hZL_DqPdx_NY6HBuB2ZFpL5cV6iDw-ofOSfuSJ4zu72M2ce_6rlrBw/exec', {
  method: 'POST',
  body: JSON.stringify(payload) // Do NOT add headers: { 'Content-Type': 'application/json' }
})
.then(response => response.json()) // Now you can read the response!
.then(result => {
  if (result.result === "success") {
    console.log("File URL:", result.link);
    showSuccessState(file.name);
  } else {
    console.error("Script error:", result.error);
    alert("Server error: " + result.error);
  }
})
.catch(err => {
  console.error("Connection error:", err);
  // If it still fails, it's usually because the Script wasn't shared with "Anyone"
});
    
    };
  }
});
}

function showSuccessState(originalName) {
  document.getElementById('displayFileName').innerText = originalName;
  document.getElementById('uploadState').classList.add('hidden');
  document.getElementById('successState').classList.remove('hidden');
} 
document.getElementById('copy-button').addEventListener('click', function() {
  const codeToCopy = "CLINDERMA300";
  
  navigator.clipboard.writeText(codeToCopy).then(() => {
    // Optional: Give the user feedback
    const textSpan = this.querySelector('.discount-code-text');
    const originalText = textSpan.innerText;
    
    textSpan.innerText = "Copied!";
    this.style.background = "#e6f4ea"; // Light green feedback
    
    setTimeout(() => {
      textSpan.innerText = originalText;
      this.style.background = "#FFFFFF";
    }, 2000);
    
  }).catch(err => {
    console.error('Failed to copy: ', err);
  });
});
 // =========================================================
// 11. MINOR SAFETY NOTE VISIBILITY LOGIC (FIXED KEY)
// =========================================================
// Use 'kylas_user_age' to match what was saved in the onSubmit function
const userAgeValue = localStorage.getItem('kylas_user_age'); 
const safetyNote = document.getElementById('minor-safety-note');

if (safetyNote && userAgeValue) {
    const age = parseInt(userAgeValue, 10);
    
    // Logic: If age is a valid number and less than 18, show the note
    if (!isNaN(age) && age < 18) {
        safetyNote.style.display = 'block';
        console.log("User age is " + age + ". Showing safety note.");
    } else {
        safetyNote.style.display = 'none';
        console.log("User age is " + age + ". Hiding safety note.");
    }
}
 // =========================================================
    // 12. REVIEW WIDGET LOAD MORE LOGIC
      const loadMoreBtn = document.getElementById('load-more-btn');
    
    if (loadMoreBtn) {
        // Log to console so you can see if the script actually finds the button
        console.log("Review button initialized");

        loadMoreBtn.addEventListener('click', function() {
            // Find all reviews that are currently hidden
            const hiddenReviews = document.querySelectorAll('.review-card.review-hidden');
            
            console.log("Hidden reviews found:", hiddenReviews.length);

            // Select the next 3 hidden reviews
            const nextBatch = Array.from(hiddenReviews).slice(0, 3);
            
            nextBatch.forEach(review => {
                review.classList.remove('review-hidden');
            });

            // If no more reviews are left to show, hide the button
            if (document.querySelectorAll('.review-card.review-hidden').length === 0) {
                loadMoreBtn.style.display = 'none';
            }
        });
    }
 
}); // THIS IS THE FINAL CLOSING TAG FOR THE ENTIRE FILE
 